module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "HA_Head1"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-7"
  }, [_vm._v("17.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("note to self")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Some guidelines for a successful ‘Grand Tour’ of Europe:")])]), _vm._v(" "), _c('p', {
    staticClass: "OL1_Ordered_list_1_First"
  }, [_vm._v("1.  "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Energy! Never be ‘too tired’ or ‘not in the mood’.")])]), _vm._v(" "), _c('p', {
    staticClass: "OL1_Ordered_list_1_Contd"
  }, [_vm._v("2.  "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Avoid conflict with Albie. Accept light-hearted joshing and do not retaliate with malice or bitter recriminations. Good humour at all times.")])]), _vm._v(" "), _c('p', {
    staticClass: "OL1_Ordered_list_1_Contd"
  }, [_vm._v("3.  "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It is not necessary to be seen to be right about everything, even when that is the case.")])]), _vm._v(" "), _c('p', {
    staticClass: "OL1_Ordered_list_1_Contd"
  }, [_vm._v("4.  "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Be open-minded and willing to try new things. For example, unusual foods from unhygienic kitchens, experimental art, unusual points of view, etc.")])]), _vm._v(" "), _c('p', {
    staticClass: "OL1_Ordered_list_1_Contd"
  }, [_vm._v("5.  "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Be fun. Enjoy light-hearted banter with C and A.")])]), _vm._v(" "), _c('p', {
    staticClass: "OL1_Ordered_list_1_Contd"
  }, [_vm._v("6.  "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Try to relax. Don’t dwell on the future for now.")])]), _vm._v(" "), _c('p', {
    staticClass: "OL1_Ordered_list_1_Contd"
  }, [_vm._v("7.  "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Be organised, but –")])]), _vm._v(" "), _c('p', {
    staticClass: "OL1_Ordered_list_1_Contd"
  }, [_vm._v("8.  "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Maintain a sense of fun and spontaneity.")])]), _vm._v(" "), _c('p', {
    staticClass: "OL1_Ordered_list_1_Contd"
  }, [_vm._v("9.  "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("At all times be aware of Connie. Listen.")])]), _vm._v(" "), _c('p', {
    staticClass: "OL1_Ordered_list_1_Last"
  }, [_vm._v("10.  "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Try not to fight with Albie.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-5"
  }, [_vm._v("18.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("posh inter-railing")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The holiday had been Connie’s idea. ‘A Grand Tour, to prepare you for the adult world, like in the eighteenth century.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I didn’t know much about it either. Connie said that it was once traditional for young men of a certain class and age to embark on a cultural pilgrimage to the continent, following well-established routes and, with the help of local guides, taking in certain ancient sites and works of art before returning to Britain as sophisticated, civilised men of experience. In practice the culture was largely an excuse for drinking and whoring and getting ripped off, arriving home with pillaged artefacts, some bottles of the local booze and venereal disease.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘So why don’t I just go to Ibiza?’ said Albie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Trust me,’ said Connie, ‘this will be much, much more fun.’ We were sitting at the kitchen table on a Sunday morning – this was in happier times, before my wife’s announcement – my old")]), _vm._v(" "), _c('i', [_vm._v("Times Atlas")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("opened on a map of Western Europe, and there was a kind of glee in Connie that I’d not seen for a while.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You have to remember this was all in the days before cheap mechanical reproduction, so the Grand Tour was their one chance to see all these masterpieces outside dodgy black-and-white engravings. All the great works of the ancient world and the Renaissance, Chartres Cathedral, the Duomo in Florence, St Mark’s Square, the Colosseum. You’d take fencing lessons, cross the Alps, explore the Roman Forum, look down into the crater of Vesuvius and walk the streets of Naples. And yes, you’d drink and whore and get into fights, but you’d come back a")]), _vm._v(" "), _c('i', [_vm._v("man")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Ibiza it is, then,’ said Albie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Come on, Egg! Play along,’ said Connie. Like an advancing general, she traced her finger across the pages of the atlas. ‘Look – we’ll start in Paris, do the obvious stops: the Louvre, the Musée d’Orsay, the Monets and the Rodins. We’ll train to Amsterdam, see Rembrandt at the Rijksmuseum, the Van Goghs, then find our way – no planes, no cars – across the Alps to Venice, because it’s Venice. Back through Padua for the Scrovegni Chapel; Vicenza for Palladio’s villas; Verona – Verona’s lovely – see")]), _vm._v(" "), _c('i', [_vm._v("The Last Supper")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in Milan; Florence, for the Botticelli in the Uffizi and, well, just for Florence – then Rome! Rome is beautiful. Stop off at Herculaneum and Pompeii and finish up in Naples. Of course, in an ideal world we’d jump back and do the Kunsthistorisches in Vienna, then Berlin, but we’ll have to see how your father’s holding up.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was emptying the dishwasher and confess to being distracted by the low level of rinse aid as well as the ruinous cost of all this travel. But she really did seem very excited by it all, and perhaps it would make a change from our recent family holidays, the three of us restless, bitten and sun-burnt in some expensive villa or fighting for our tiny share of the Mediterranean coast.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Albie remained sceptical. ‘So, basically I’m going inter-railing with my mum and dad.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That’s right, you lucky boy,’ said Connie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But if it’s meant to be this great rite of passage and you’re both there, doesn’t that sort of defeat the object?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, Egg, because you’re going to learn about art. If you were serious about painting in those days, this was your training, your university")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Same thing now. You can sketch, take photos, suck it all in. If you want to do it for a living, you have to see these things—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘A lot of Old Masters, a lot of dead white Europeans.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘—even if it’s just so you’ve got something to kick against. Besides, Picasso’s a dead white European, and you love Picasso.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Can we see")]), _vm._v(" "), _c('i', [_vm._v("Guernica")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("? I’d love to see")]), _vm._v(" "), _c('i', [_vm._v("Guernica")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘"), _c('i', [_vm._v("Guernica")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("’s in Madrid. We’ll do it another time.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Or you could just give me the money and I’ll go alone!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘This way it’s")]), _vm._v(" "), _c('i', [_vm._v("educational")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(",’ said Connie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘This way you get out of bed in the mornings,’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Albie groaned and laid his head on his arms, and Connie took to twisting her finger in the hair at the nape of his neck. They do this, Connie and Albie, grooming each other like primates. ‘We’ll have fun, too. I’ll make sure your father schedules some in.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Every fourth day, is that too much?’ I returned to the machine. Not just rinse aid, salt too; it was burning through the stuff, and I wondered how I might recalibrate the settings.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You can still meet girls and get drunk,’ said Connie. ‘You’ll just have to do it with me and your father watching. And pointing.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Albie sighed and rested his cheek on his fist. ‘Ryan and Tom are going backpacking in Colombia.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘And you can too! Next year.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No he can’t,’ I shouted into the dishwasher. ‘Not Colombia.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Shut up, Douglas! Egg, sweetheart, this will probably be the last summer holiday we’ll have together.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I looked up, striking my head sharply on the edge of the kitchen unit. The last ever? Was it? Was it really?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘After this, you’re on your own,’ said Connie. ‘But for now let’s try and have a nice time this summer, shall we? This one last time?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Perhaps she’d been planning her escape, even then.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-5"
  }, [_vm._v("19.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("hissing in fields")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When my wife told me that she was going with the turning of the leaves, did my life come to an end? Did I fall to pieces or fail to make it through the days?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Of course there were further sleepless nights, further tears and accusations in the lead-up to the trip, but I had no time for a nervous breakdown. Also, Albie was completing his ‘studies’ in art and photography, returning exhausted from screen-printing or glazing a jug, and so we were discreet, walking our dog, an ageing Labrador called Mr Jones, some distance away from the house and hissing over his head in fields.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I can’t believe you’ve sprung this on me!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I haven’t")]), _vm._v(" "), _c('i', [_vm._v("sprung")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it, I’ve been feeling this way for years.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You haven’t said anything.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I shouldn’t have to.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Springing this on me, at this time . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’m sorry, I’ve tried to be as honest as I—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I still think we should cancel the Grand Tour . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Why do we have to?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You still want to go? With this hanging over us?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I think so—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘A funeral cortège, backpacking through Italy . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It needn’t be like that. It could be fun.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘If you want to cancel the hotels you need to say now.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’ve just told you, I want us to go. Why don’t you ever listen to—?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Because if you’re really trapped in such a living hell—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Don’t be melodramatic, love, it doesn’t help.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I don’t know why you suggested it if you didn’t want to—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I did want to, I still do!’ She stopped and held my hand. ‘Let’s put the other decision on hold until the autumn. We’ll all go on the trip, we’ll have a fantastic time with Albie—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘And then we’ll come back and say goodbye? You won’t even have to bother unpacking, you could just chuck your suitcase in a taxi and head off . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("At which point she sighed and looped her arm through mine as if nothing were wrong. ‘Let’s see. Let’s see what happens.’ And we walked Mr Jones back to the house.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("20.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("maps")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A route took shape: Paris, Amsterdam, Munich, Verona, Venice, Florence, Rome and Naples. Of course Connie had been to most of these places before, on an epic odyssey of smoking cannabis and kissing local boys, working as a waitress, a tour guide, an au pair in the years before she started art school. In the early days of our relationship, when my work and our puny finances permitted it, we would sometimes take cheap flights to European cities and Connie would spot a bench, a bar or café and lapse into a reverie about the time she and her friends spent a week sleeping on the beach in Crete, or the wild party she had been to in an abandoned factory outside Prague, or the un-named boy she’d fallen madly in love with in Lyon in")]), _vm._v(" ’84, "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the Citroën mechanic with his strong hands and broken nose and the smell of engine oil in his hair. I’d find a smile and change the subject, but clearly ‘well travelled’ meant something different to Connie. Been there, done him, that was our joke. Europe represented first love and sunsets, cheap red wine and breathless fumbling.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’d had no such rite of passage, partly because of my father, a fierce patriot who raged against the whole world’s bloody-minded refusal to knuckle down, learn decent English and live like us. Anything that suggested ‘abroad’ made him suspicious: olive oil, the metric system, eating outdoors, yoghurt, mime, duvets, pleasure. His xenophobia was not limited to Europe; it was international and knew no borders. When my parents came to London to celebrate my PhD, I made the mistake of brandishing my cosmopolitanism by taking them to a Chinese restaurant in Tooting. Chiang Mai’s fulfilled my father’s key restaurant criteria in that it was unnervingly cheap and brutally over-lit (‘so you can see what you’re bloody well eating!’) yet I still recall the expression on his face when handed a pair of wooden chopsticks. He pointed them at the waiter, like a switchblade. ‘Knife and fork. Knife. And. Fork.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Of course we argued about this. The Channel Tunnel, he said, was ‘like leaving your front door open’. What did he imagine might happen? I asked. A great, marauding horde of toreadors")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and trattoria waiters and onion-sellers pouring out into Folkestone,")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Kent? In fairness, my father had lost his own father in Belgium in")]), _vm._v(" 1944, "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and perhaps this provided some deep-seated justification for his hostility, but still, it was irrational in such a rational man. To my father, ‘abroad’ was a strange, unknowable place where the milk tasted odd and lasted an unnaturally long time.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("So I was not well travelled; in fact I barely knew Europe until I met Connie. Wherever we went, she had been there before. Her European map was already dense with red pins signifying stolen rucksacks, missed flights, languorous kissing in ornamental parks, pregnancy scares, fresh oranges off the tree and ouzo for breakfast. On my very first visit to her flat I had glimpsed several photographs stuck to her fridge, new-wave Connie and her art-school friends with gelled perms, blowing kisses at the camera or smoking topless – topless! and with cigarettes! – on a balcony in Sicily.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('i', [_vm._v("My very first visit to her flat")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’m not even through the door yet. She’s still talking to Jake.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-7"
  }, [_vm._v("21.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the ejector-seat")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("After my sister’s ironic sherry trifle had been disposed of we were all encouraged to swap places and ‘mingle’, Connie and Jake vacating their chairs at ejector-seat speed. ‘Mingling’, it transpired, involved continuing their conversation at a different part of the table, and I watched as the acrobat produced from somewhere, I don’t know where – from his tights, perhaps – a small plastic Ziploc bag of dusty sweets which he offered to Connie, who accepted with a nod, almost a shrug of resignation, before passing the bag to my sister and on around the table. They couldn’t have been very nice sweets, because everyone was grimacing and washing them down with water. Soon I found myself sitting between two actors on drugs, a position that, a number of peer-reviewed research papers have since confirmed, is precisely the worst place a biochemist can be. One of the actors had been performing excerpts from his one-person show, to my mind one person too many and when the Ziploc bag reached us, he broke off and, shook it underneath my nose. At the end of the table, I caught a glimpse of my sister nodding, nodding, eyes wide in encouragement.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No thanks,’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You don’t partake?’ said the actor, pouting. ‘You should! Have a cheeky half, it’s lovely.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’m sorry, but the only acid in my house is deoxyribonucleic—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Hey, has anyone got any chewing gum?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I left the table.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Karen intercepted me in her bedroom where I was searching through great piles of overcoats.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You’re going? It’s not even ten!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I don’t really think it’s my “scene”, Karen.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You don’t know until you try it.’ She was looking terrifically pleased with herself, my sister. Not quite brave enough to rebel in my parents’ presence, she enjoyed using me as their proxy. I was simply the nearest old square to hand. ‘Why are you so boring, D?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Oh, I practise every night.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It drives me crazy!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Just as well I’m leaving, then.’ I had found my coat and was wrapping my scarf around my neck.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Stay and try it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Why not?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Because I don’t want to, pusher-man! Why are you so keen for me to do something that I don’t want to do?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Because I think you should try things! It might reveal a new part of your personality.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well, I’m sorry to disappoint you, but this is it. This is everything, this is all there is.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Karen placed her hand on my chest. ‘I think Connie likes you.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Oh. Really.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘In fact she told me so.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You are such a liar, Karen.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘She said she found you very interesting, even all that science stuff. She said it made a change to meet someone who was interested in something other than themselves.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I can’t find my other glove. There’s a glove here somewhere . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘She said she found you very attractive.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I laughed. ‘Then the drugs have kicked in.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I know! I was as surprised as you.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘And what makes you think I like her?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Your lolling tongue. Also, you’d be insane not to. Everyone loves Connie, she’s amazing.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘If you find my other glove, can you keep it for me please? It looks like . . . well, this one. Obviously.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Karen blocked my way to the bedroom door, and began unwrapping the scarf from my neck. ‘Stay. Just for half an hour. The moment people start touching each other’s faces, then you can go.’")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-5"
  }, [_vm._v("22.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a blurred photo")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_vm._v("It did not take long for the 3,4-methylenedioxy-N-methylampthetamine to seep through the bedrock of tuna pasta bake. It was as if an invisible presence were wandering the room, tapping people on the head with a wand that turned them into idiots.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Let’s sit soft!’ commanded my sister, eyes goggling, and the guests moved from the kitchen. I put the Pyrex in to soak before being dragged into the tiny living room, which was decked out as a kind of shabby harem with pillows on the floor, candles recklessly tickling the bottom of curtains and the air grey with cigarette smoke. Carole King’s")]), _vm._v(" "), _c('i', [_vm._v("Tapestry")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was replaced by something with a tinny snare and choppy piano. The word ‘bass’ was rhymed with ‘face’ and soon the dancing began. One of Karen’s friends, I noticed, was topless under dungarees.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was beginning to feel foolish. It was like waiting in a queue for a rollercoaster that I had no intention of riding. Why did I remain, leaning in a corner, making stilted conversation with a dramaturg? My motivation slouched on a beanbag, Jake curled up at her feet like an immense ginger cat. Karen was right; I had liked this girl immediately. I liked her obvious intelligence, the keen attention she directed at people. I liked the humour that played perpetually in the corner of her mouth and smudged eyes. And I found her attractive, of course – her face, her figure . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Well, these days, Connie’s figure is the subject of perpetual care and a recurring circular argument –")]), _vm._v(" "), _c('i', [_vm._v("I look awful, no you don’t, yes I do, you look wonderful")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("– an endless rally that I can do nothing to break. She feels, has always felt, that she is too large. You look wonderful to me, I say. She shrugs this away. I look like a blurred photo of myself, she says, I no longer have cheekbones – as if this was what anyone wanted in a face: bones. The truth is I feel the same way about her now as I did back then, which is to say very strongly. We had so little in common and yet she seemed to me to have more wit and grace and")]), _vm._v(" "), _c('i', [_vm._v("life")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("in her than anyone in that crowded room, or indeed my world at that time.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("So I waited, and eventually she caught my eye and smiled wonderfully, and Jake’s eyes followed too. He growled and tried to take her wrist as she stood – a little unsteadily, I noticed. She removed his hand and crossed the room towards me.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I excused myself from the dramaturg.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-5"
  }, [_vm._v("23.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("magnets")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You’re still here!’ she said in my ear.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Just for a while,’ I said in hers.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I wanted to apologise. We didn’t really get a chance to speak at dinner. Jake’s very interesting, but he doesn’t have much of a sense of humour. Or curiosity.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, I noticed.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I liked it when you threatened to cut off his legs.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Did I do that? I did, didn’t I?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I was watching your face. You got very eloquent, very passionate. Of course I didn’t understand half of what you were saying. I’m completely remedial when it comes to science. I don’t know what revolves around what, or why the sky’s blue, or the difference between an atom and a molecule. It’s embarrassing, really. I took my niece to the seaside last summer and she asked me why the tide came in and out and I told her it was something to do with magnets.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I laughed. ‘Well it’s one theory, I suppose.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She put her hand on my arm")]), _vm._v(". ‘"), _c('i', [_vm._v("Is")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it magnets? Please, please tell me it’s magnets!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was in the process of explaining the influence of the moon’s gravitational pull on large bodies of water, when she paused and put her hands on her chest and opened her eyes wide.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Sorry,’ she said, ‘I just got a bit of a rush. Are you feeling it yet?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The drugs? Oh, I don’t really do that kind of thing.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Very sensible. Very.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We looked around the room. The drugs seemed to be having a devastating effect on people’s posture, with everyone hunching their shoulders and bobbing their heads in a sort of hyper-tense disco. My sister in particular was scrunched up like a squirrel, sucking her lips inwards in concentration as she shook tiny imaginary maracas.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Look at them,’ said Connie, shaking her head. ‘People always say")]), _vm._v(" "), _c('i', [_vm._v("take this, drink that, you’ll lose your inhibitions")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("What we need is something that’ll give them back.")]), _vm._v(" "), _c('i', [_vm._v("Here, try this, it’ll make you massively sensible")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We’d all have a much better time. Imagine waking up and saying to yourself, “Christ, I was")]), _vm._v(" "), _c('i', [_vm._v("totally")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("inhibited last night.”’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Actually, that’s exactly what I do say.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She laughed, for the first time I think. ‘Lucky you! Sounds lovely.’ There was a brief moment where we did nothing but smile, then: ‘It’s very loud in here. I need some water. Can we go in the kitchen?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I noticed Jake, his hooded eyes glaring territorially. ‘Actually, I was about to head off home.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Douglas,’ she said over her shoulder, reaching out her hand, ‘you give in")]), _vm._v(" "), _c('i', [_vm._v("far")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("too easily,’ and I wondered what she meant as I followed her through.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("24.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("spatula")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In the kitchen I battled with my desire to wipe down all the surfaces.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Your sister tells me you’re some kind of genius.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well, my sister has a low “genius” threshold. She says the same about practically everyone in that room.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That’s different, though, isn’t it? That’s talent, and not even talent most of the time. Self-confidence, that’s what it is. When she says “genius” she just means they’ve got a really loud voice. You, you actually know things. Tell me again, about the fruit flies.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I did my best to explain in layman’s terms, while she stood at the sink and drank water from a pint glass in one long gulp, then remained standing with her head thrown back, a good deal of water running the length of her neck.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘. . . then we take the next generation of fruit flies and examine how the chemical agents have altered the . . . are you all right?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Coming round, she blinked and shook her head a little. ‘Me? Yeah, I’m fine, I drank a little too much and now . . .’ She sighed and drew her hands down her face. ‘Christ, that was a bright idea! I’ve just broken up with someone, you see.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Oh, I’m sorry.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, it was the right thing to do, it was a terrible relationship, it’s just . . . it was four years, you know?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘A long time.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Keep talking to me, won’t you? Don’t go away.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I had no intention of going away. ‘So we look for changes in the fly’s pheno—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You seeing someone, Douglas?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Me? No, not at the moment, not for some time. Pressure of work,’ I said, as if this were the reason.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I knew you were single.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Is it really so obvious?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, I mean your sister told me. I think she’s been trying to fix us up.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes. Yes, I’m sorry about that.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Don’t apologise. Not your fault. She’s convinced that I’d be good for you. Or was it the other way around? Either way, nothing’s going to happen.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Oh.’ This struck me as unnecessarily blunt. ‘No, well, I suspected that.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Sorry, sorry, not because of you – you seem really, really nice – just because, you know, rebound and everything. I’m a bit . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A moment passed. ‘I presumed you were interested in—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Jake? God, no!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It seemed that way at dinner.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Did it? I’m sorry, I wanted to talk to you but he just wouldn’t stop and – Jake? Really, not for me. Can you imagine that flying through the air towards you, like a great hennaed bear, arms outstretched. I’d keep my hands deep in my pockets, safety net or no safety net.’ She poured red wine into the pint glass then gulped it down as if it were lemon barley water. ‘If I wanted a self-absorbed egomaniac, I’d call my ex.’ She pointed an unsteady finger at me. ‘Don’t let me call my ex!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I won’t.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There was a pause, and she smiled. Lipstick had been replaced by the black stain of the wine, and her dark fringe was now sticky with sweat. Pupils dilated, her eyes were wonderful. She tugged at the front of her dress. ‘Is it hot in here, or is it me?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s you,’ I said. I had been considering what it would feel like to kiss her, weighing this against what it would feel like to miss the last tube. The kiss felt possible, but it felt un-gentlemanly to take advantage of standards that had been chemically lowered. Which was clearly the case, because now she shivered and smiled and said:")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Please don’t misinterpret this, Douglas, but would you mind coming over here and just . . . holding me?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("At which point a fiery ball of hair barrelled low into the kitchen, scooped her up and dangled her over his shoulder. ‘Are you hiding from me, little lady?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Actually, can you put me down please, Jake?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Scuttling away with Doctor Frankenstein . . .’ He was shifting her on his shoulder now, as if adjusting a roll of carpet. ‘Come and dance with me. Now!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Stop it, please!’ She seemed embarrassed, upset, her face red.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Jake, I think you should put her—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Here, watch this. Can you do this, Doctor Frankenstein?’ And with an ease that would have been admirable if Connie had been willing, he tossed her into the air and caught her on the palms of his hands, his elbows locked so that her head bounced against the lightshade. Her black dress had ridden up and with one hand she tugged it down, the smile on her face fixed and mirthless.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I said, put. Her. Down!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I could hardly believe the voice was mine, or indeed the hand that was now at arm’s length, brandishing a plastic spatula flecked with tuna pasta bake. Jake glanced at the spatula, then at me, then laughed, rolled Connie down to the ground and with a dainty big-top skip, left the kitchen. ‘Prick-tease!’ was his parting shot.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I hope they take away your safety net!’ shouted Connie, tugging at her dress’s hem. ‘Conceited bastard.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Are you all right?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Me? I’m fine. Thank you.’ I followed her glance. The rubber utensil was still in my hand. ‘What were you planning to do with that?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘If he didn’t put you down, I was going to make him eat something.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She laughed, rotated her shoulders and put her hand to her neck as if assessing the damage. ‘I feel terrible, I have to go outside.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’ll come with you.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘In fact . . .’ She put her hand on my arm ‘. . . more than that, I have to go home.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The tubes have stopped running.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That’s all right, I’ll walk.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Where do you live?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Whitechapel.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Whitechapel? That’s eight, ten miles away.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘S’all right, I’d like to. I’ve got a change of shoes. I’ll be fine, it’s just . . .’ She placed both hands on her chest. ‘I need to walk this off and if I’m by myself I’m going to . . . crash into something. Or someone.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’ll come with you,’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A moment passed. ‘Thank you,’ she said. ‘I’d like that.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I should go and say goodbye.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No.’ She took my hand. ‘Let’s make a French exit.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What’s a French exit?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s when you leave without saying goodbye.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’ve never heard that before.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A French exit; no")]), _vm._v(" "), _c('i', [_vm._v("thank you for having me")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("no")]), _vm._v(" "), _c('i', [_vm._v("I’ve had a lovely time")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To just walk away, cool and aloof. I wondered if I could.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-5"
  }, [_vm._v("25.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("mr jones")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The morning of departure we awoke at five thirty a.m. and said a fond goodbye to Mr Jones, who was to be cared for by our neighbours, Steph and Mark, for the month-long duration of the Grand Tour. We were always surprised by how much we missed Mr Jones. Even in canine terms he is basically an idiot, perpetually running into trees, falling into ditches, eating daffodils. A ‘sense of humour’, Connie calls it. Throw Mr Jones a stick and more likely than not he will return with a pair of discarded underpants. Monumentally flatulent, too – weapons-grade. But he is foolish, loyal and affectionate and Connie is entirely devoted to him.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Bye, old pal, we’ll send you a postcard,’ she cooed, nuzzling at his neck.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Don’t think there’s much point sending a postcard,’ I said. ‘He’ll only eat it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Connie sighed deeply. ‘I’m not really going to send him a postcard.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, no, I realised that.’ We had been wilfully misinterpreting each other’s jokes since Connie’s warning of departure. It hummed away beneath everything we did, however innocuous. Even saying goodbye to Mr Jones contained the question: who will get custody?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And so we roused Albie, for whom rising before eight a.m. was an infringement of his basic human rights, then took a taxi to Reading and crammed onto a commuter train to Paddington, Albie sleeping en route, or pretending to do so.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Despite my resolutions, we had argued the night before, in this instance about the acoustic guitar that Albie insisted on dragging across Europe – an absurd and impractical affectation, I thought – and there was the usual stomping up the stairs, Connie’s familiar sigh, her famous slow head-shake.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’m worried he’s going to busk,’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘So let him busk! There are worse things a seventeen-year-old can do.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’m worried that he’s going to do those, too.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But it seemed the guitar was as essential as his passport. Needless to say it was I who bundled the case through the turnstiles at the Eurostar terminal, lugged it through security, crammed it into inadequate luggage space on the train as we took our seats where I began swabbing with napkins at the hot coffee now dripping from my wrist. There’s a particular grubbiness that comes with travel. You start showered and fresh in clean and comfortable clothes, upbeat and hopeful that this will be like travel in the movies; sunlight flaring on the windows, heads resting on shoulders, laughter and smiles with a lightly jazzy soundtrack. But in reality the grubbiness has set in before you’ve even cleared security; grime on your collar and cuffs, coffee breath, perspiration running down your back, the luggage too heavy, the distances too far, muddled currency in your pocket, the conversation self-conscious and abrupt, no stillness, no peace.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘So – goodbye England!’ I said to fill the gap. ‘See you in four weeks!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘We’ve not left yet,’ said Albie, his first words to me for twelve hours, then produced his Nikon and started taking close-up photographs of the bottom of his shoe.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("26.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("albert samuel petersen")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Albie is dark, like his mother; his hair black, tangled and long, dangling into his eyes and scratching at the corneas so that I constantly want to lean across to brush it out of the way. Eyes large and brown and wet – ‘soulful’ is a word that gets bandied about – the dark skin around them the colour of a bruise. He has a long nose, a full, dark mouth and is, by all accounts, an attractive young man. One of Connie’s female friends said that he looked like a murderous ruffian in a Caravaggio, a comparison that meant nothing to me until I looked it up. But clearly there is a demand out there for late-Renaissance muggers with scrappy facial hair and consumption, because girls seem drawn to him, feel they can ‘really talk’ to him, and I’ve long since given up keeping track of the Rinas and Ninas and Sophies and Sitas for whom surliness, irresponsibility and poor personal hygiene are such irresistible traits.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But he is")]), _vm._v(" "), _c('i', [_vm._v("cool")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("they say, he is deep; people are drawn to him and in this respect, as in all others, he is his mother’s son. He is ‘not a natural academic’, according to his college tutor, ‘but he has wonderful")]), _vm._v(" "), _c('i', [_vm._v("emotional intelligence")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("’,")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a phrase that made my teeth snap together. Emotional intelligence, the perfect oxymoron! ‘How do they test")]), _vm._v(" "), _c('i', [_vm._v("emotional")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("intelligence? What qualification does that lead to?’ I asked Connie as we drove home. ‘Perhaps there’s a multiple-choice element. They put you in a room with six people and you have to work out who to hug.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It means he has empathy,’ she replied dryly. ‘It means he has some awareness of and interest in other people’s feelings.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And so it seems the only thing that Albie has taken from my side of the family is my father’s skinny height, yet he seems embarrassed and resentful even of this, with his round shoulders and stooped, loping walk, arms dangling, as if unable to manage the weight of his hands. Oh, and smoking, he’s taken that from my father, too. In consideration of my views on the subject, he smokes in secret, though it’s not a secret that he holds precious, given the number of lighters and Rizla packets he leaves lying around, given the smell of it on his clothing and the burn marks on the window ledge of his filthy bedroom. ‘How did they get there, Albie?’ I said. ‘The swallows? Smoking swallows, with their Duty Free?’ at which point he laughed and kicked the door closed. Oh, and as well as the emphysema, cancer and heart disease that he is presumably nurturing in that narrow chest, he suffers from a malaise that requires at least twelve hours of sleep, and yet is singularly incapable of commencing these twelve hours before two a.m.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("What else? He is fond of T-shirts with absurdly low-cut v-necks so that his sternum is constantly on display, and he has a habit of withdrawing his arms through the sleeves and jamming his hands into his armpits. He refuses to wear a coat, an absurd affectation, as if coats were somehow ‘square’ or un-cool, as if there were something ‘hip’ about hypothermia. What is he rebelling against? Warmth? Comfort? ‘Let it go’, says Connie, as he strides out into some gale with his rib-cage showing, ‘it won’t kill him’ – but it might, and if it doesn’t then the sheer frustration of it all will kill me. Take, for example, the state of his bedroom, a room so filthy that it is effectively a no-go zone, an immense Petri dish of furry toast crusts and lager tins and unthinkable socks that will one day have to be sealed off in concrete like Chernobyl, and this is not just laziness on his part – no, real effort has gone into a situation designed to cause the maximum upset. To me! Not to his mother, but to me, to me, so that it is no longer simply a bedroom, it is a massive act of spite.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And he’s a mumbler, a swallower of words. Despite spending the last six years in a perfectly nice part of Berkshire, he speaks in a bored cockney drawl because God forbid anyone should think his father has done well or worked hard, God forbid anyone should think that he’s comfortable and cared for and loved, loved equally by both of his parents even if he only seems to desire and require the attentions of one.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In short, my son makes me feel like his step-father.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I have had some experience of unrequited love in the past and that was no picnic, I can tell you. But the unrequited love of one’s only living offspring has its own particular slow acid burn.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-5"
  }, [_vm._v("27.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("helmut newton")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But now the train had finally begun to move, and Albie had switched the fearless truth-telling eye of his camera lens from his untied laces to the walls of the tunnels under east London, because you can never have enough pictures of dirty concrete.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I hope you’re going to take lots of pictures of the Eiffel Tower, Egg,’ I said, in an affectionate, teasing tone. ‘Me and your mother standing in front with our thumbs up?’ We demonstrated. ‘Or – another tip – I can put my hand out flat like this, so it looks like I’m holding it . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That’s not photography, that’s")]), _vm._v(" "), _c('i', [_vm._v("holiday snaps")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".’ It seemed the tendency to wilfully misinterpret jokes was contagious. Connie winked at me and squeezed my knee beneath the table.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My son was soon to study photography on a three-year course which we were financing and although my wife, who knew about these things, insisted that he had talent, an ‘eye’, the fact of it filled me with an anxiety that I fought daily to suppress. At one point he had been intending to study theatre – theatre! – and at least I had managed to nip that in the bud, but now it was photography, the latest of a long series of temporary passions – ‘street art’, skateboarding, DJ-ing, drumming – the abandoned detritus of which cluttered cellar, attic and garage, alongside the optimistic chemistry set that I had bought and he had tossed aside, the hopeful microscope that had never been unpacked, the dusty box that offered an opportunity to ‘Grow Your Own Crystals!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But there was no denying his enthusiasm. Albie with a camera was something to see, crouching and contorting his long body into a question mark as if playing the role of ‘photographer’. Sometimes he fired off frames at arm’s length, in what I believe is called ‘gangster style’, sometimes on tiptoe, back arched like a toreador. Initially I made the mistake of standing and grinning when the camera was produced, but soon realised that he wouldn’t actually press the shutter until I’d stepped out of the frame. In fact, in all the thousands of shots that he had taken, many of them loving portraits of his mother – her eyes, her smile – alongside his usual repertoire of wet cardboard boxes and badgers hit by cars, etc., there was not a single photograph of me. Not of my face, anyway, just an extreme close-up of the back of my hand, black and white in heavy contrast, part of a college project that I later discovered was called ‘Waste/Decay’.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Albie’s passion for photography had been the cause of tension in other ways. I had a printer in my office, a top-of-the-range colour model whose features included glacial speed and shocking running costs. Consequently, I was more than a little annoyed to return from work one day and hear the printer grinding away. Irritably, I examined the top print of a sizeable pile of")]), _vm._v(" 8x10s. It seemed to be a high-contrast, minutely detailed black-and-white print of some kind of dark moss and only when I peered more closely did I realise that this was in fact a photograph of a naked female form, shot in profile so to speak. I dropped the photograph, then gingerly examined the shot beneath. In washed-out black and white, it might have passed for some sort of snowy mountain range, were it not for the pale dimpled nipple that crowned the peak. Meanwhile, a third image was rumbling its way out of the machine and from the section that was visible, there seemed every chance that buttocks were emerging.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I called Connie in. ‘Have you seen Albie?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘He’s in his room. Why?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I held up the photographs and predictably, her response was to clasp her hand to her mouth and laugh. ‘Oh, Egg. What")]), _vm._v(" "), _c('i', [_vm._v("have")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you been up to?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Why can’t he just photograph someone’s")]), _vm._v(" "), _c('i', [_vm._v("face")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("for once?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Because he’s a seventeen-year-old boy, Douglas. This is what they do.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I didn’t. I photographed wildlife. Birds and squirrels and iron-age forts.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Which is why you’re a biochemist and he’s a photographer.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I wouldn’t mind so much, but does he have any idea how much the cartridges cost for this thing?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Connie, meanwhile, was peering closely at the buttocks. ‘My money’s on Roxanne Sweet.’ She held the photograph to the light. ‘I think they’re rather good. Of course he’s pinched it all off Bill Brandt, but they’re not bad.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Our son, the pornographer.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s not")]), _vm._v(" "), _c('i', [_vm._v("pornography")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it’s a nude study. If he was painting nudes at a life-drawing class you wouldn’t bat an eyelid.’ She pinned the print to my office wall. ‘Or at least I’d hope you wouldn’t. Who knows any more?’")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("28.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("passion")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Soon after, Albie announced his intention to devote his life to a hobby. Why, I asked Connie, could he not study a more practical subject and do the things he enjoyed at weekends and in the evenings, like the rest of us? Because that’s not how an arts-based course works, said Connie; he needs to be challenged, to develop his famous ‘eye’, learn to use his tools. But wouldn’t it be cheaper and quicker to just read the manual? I could understand if people still used darkrooms as I had as a young man, but all of that know-how was obsolete, and how could Albie hope to excel in a field where anyone with a phone and a laptop could be broadly proficient? It wasn’t even as if he wanted to be a photojournalist or a commercial photographer, taking pictures for newspapers or advertisements or catalogues. He didn’t want to photograph models or weddings, athletes, or lions chasing gazelles, photographs that people might pay for, he wanted to be an")]), _vm._v(" "), _c('i', [_vm._v("artist")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to photograph burnt-out cars and bark, taking pictures at such angles that they didn’t look like anything at all. What would he actually")]), _vm._v(" "), _c('i', [_vm._v("do")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("for three years, apart from smoke and sleep? And what professional job could he hope for at the end of it?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Photographer!’ said Connie. ‘He’s going to be a photographer.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We were pacing around the kitchen, furiously tidying up, by which I mean tidying up, furious. Wine had been drunk and it was late, the end of a long, fraught argument that, as was his way, Albie had provoked then fled from. ‘Don’t you see?’ said Connie, hurling cutlery at the drawer. ‘Even if it’s hard, he has to try! If he loves it, we have to let him try. Why must you always have to stomp on his dreams?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’ve got nothing against his dreams as long as they’re attainable.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But if they’re attainable then they’re not dreams!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘And that’s why it’s a waste of time!’ I said. ‘The problem with telling people that they can do anything they want to do is that it is objectively, factually inaccurate. Otherwise the whole world would just be ballet dancers and pop stars.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘He doesn’t want to be a pop star, he wants to take photographs.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘My point still stands. It is simply not true that you can achieve anything if you love it enough – it just isn’t. Life has limitations and the sooner he faces up to this fact then the better off he’ll be!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Well, that’s what I said. I believed I had my son’s best interests at heart. That was why I was so vocal, because I wanted him to have a secure professional life, a good life. Listening up in his bedroom, no doubt he had caught all of my words and none of my intention.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Still, the argument was not my finest moment. I had become shrill and dogmatic but even so I was surprised to discover that Connie was now standing still, wrist pressed to her forehead.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘When did it start, Douglas?’ she said, her voice low. ‘When did you start to drain the")]), _vm._v(" "), _c('i', [_vm._v("passion")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("out of everything?’")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("29.")]), _vm._v(" "), _c('i', [_vm._v("world of wonder")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘So why did you become a scientist?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Because I never really wanted to do anything else.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But why . . . I’m sorry, I’ve forgotten the subject . . . ?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Biochemistry, that’s my PhD. Literally the chemistry of life. I wanted to know how we work; not just us, all living things.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘When was this?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Eleven, twelve.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Connie laughed. ‘I wanted to be a hairdresser.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well, my mum was a biology teacher, dad was a GP, so it was in the air.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But you didn’t want to be a doctor?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I thought about it, but I wasn’t sure about my bedside manner, and the great thing about biochemistry over medicine, my dad said, was that no one ever asked you to look up their bum.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She laughed, which I found intensely gratifying. Clapham High Street late at night is not the most scenic of routes, and at a little after one in the morning it has its own perils, but I was enjoying talking to her – or talking at her because she was, she said, ‘too off her face’ to do much but listen. It was a bitterly cold night, and she clung to my arm, for warmth I supposed. She had swapped her high heels for clumpy trainers, and wore a wonderful old black coat with some kind of feathery collar, and I felt intensely proud and protective, and strangely invulnerable too, as we strode past the drunks and muggers, the hens and stags.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Am I being very boring?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Not at all,’ she said, her eyelids heavy. ‘Keep talking.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘They used to buy me this magazine,")]), _vm._v(" "), _c('i', [_vm._v("World of Wonder")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("or something it was called – my parents wouldn’t allow the other ones, the silly ones,")]), _vm._v(" "), _c('i', [_vm._v("Dandy")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("or")]), _vm._v(" "), _c('i', [_vm._v("Whizzer and Chips")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("or whatever, in the house. So I used to read this terribly dry, old-fashioned magazine and it was full of projects and diagrams and jolly things to do with vinegar and bicarbonate of soda, how to turn a lemon into a battery—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You can do that?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I have that power.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You")]), _vm._v(" "), _c('i', [_vm._v("are")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a genius!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Thanks to")]), _vm._v(" "), _c('i', [_vm._v("World of Wonder")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Fun facts! Did you know caesium has atomic number")]), _vm._v(" 55? That sort of thing. Of course at that age you’re just like this big sponge, so it all went in, but the bit I loved the best was this cartoon strip, “Lives of the Great Scientists”. There was one about Archimedes, I could draw it for you now: Archimedes in his bath, making the connection between volume and density, dancing naked down the street. Or Newton and his apple, or Marie Curie . . . I loved this idea of the sudden beautiful realisation. A light bulb going on, literally for Edison. One individual experiences this flash of insight and suddenly the world is altered fundamentally.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I hadn’t spoken this much for years. I hoped, from Connie’s silence, that she was finding me fantastically interesting, but when I looked her eyes were rolled far back into her head.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Are you all right?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’m sorry. I’m just rushing my tits off.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Oh. Okay. Should I stop talking?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, I love it. You’re bringing me down, but in a good way. Wow. Your eyes look massive, Douglas. They’re taking up your whole face.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Okay. So . . . should I keep talking, then?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes, please. I like listening to your voice. It’s like listening to the Shipping Forecast.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Boring.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Reassuring. Let’s keep walking. Tell me more.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Anyway, these stories were nonsense for the most part, or hugely over-simplified. Most scientific progress is a slog, and more often than not it stems from a dialogue within a community, lots of people thinking along the same lines and inching forward, rather than these great bolts of lightning. Newton did see the apple fall, but he’d been thinking about gravity well before that. The same with Darwin, he didn’t wake up one day and think: natural selection! There’d been years and years of observation, discussion and debate. Good science is slow-moving, methodical, evidence-based. Method. Results. Conclusion. Like my old tutor used to say, “To")]), _vm._v(" "), _c('i', [_vm._v("assume")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("makes an")]), _vm._v(" "), _c('i', [_vm._v("ass")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("of")]), _vm._v(" "), _c('i', [_vm._v("u")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and")]), _vm._v(" "), _c('i', [_vm._v("me")]), _vm._v("!”’ Here, rather optimistically, I had hoped she might laugh, but she was staring open-mouthed at her wiggling fingertips. ‘Still, I was hooked. It seemed heroic, or at least the kind of heroism I might have access to. Normal boys aspired to be footballers or pop stars or soldiers, and I wanted to be a scientist, because wouldn’t it be incredible to have a moment like that? An entirely original idea. A cure, an insight into space and time, a water engine.’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Anything occurred to you?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Not as yet.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well it’s still early days!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Of course it was all a lot easier in the past. Much easier to make your mark when people still thought the sun revolved around the earth and there were four bodily humours. Not much chance of me making that kind of breakthrough now.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Oh no!’ she said with real feeling. ‘That’s not true!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘’Fraid so. Science is a race, you’ve got to get there first. There’s no second prize. Look at Darwin – those ideas were in the air, but he was the first to get his paper published. The only way I could really make a mark now is to be transported back to, say,")]), _vm._v(" 1820. "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’d jot down some pointers on evolutionary theory. I’d explain to the Royal College of Surgeons exactly why washing your hands is a good idea. I’d invent the combustion engine, the light bulb, the aeroplane, photography, penicillin. If I could get back to")]), _vm._v(" 1820, "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I’d be the greatest scientist the world has ever known, greater than Archimedes or Newton or Pasteur or Einstein. The only obstacle is being a hundred and seventy years too late.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Clearly, what you need to do,’ she said, ‘is invent a time machine.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Which is theoretically impossible.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘There you go again, being negative. If you can make a battery out of a lemon, how hard can it be? I’m sure you could do it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You hardly know me.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But I can")]), _vm._v(" "), _c('i', [_vm._v("tell")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I have a sense. Douglas, some day you are going to do something quite amazing.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She was very far from sober, of course, but, if only for a moment, I thought she really did believe this of me. Even that it might be true.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("30.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("tunnels and bridges")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And so we journeyed on, three of us now, in what I chose to take as a companionable silence, sneaking out of London through the back door and surfacing in dreary countryside, all pylons and motorways, a sudden glimpse of a river – the Medway? – crammed with holiday cruisers sulking in the overcast English summer, then more scrappy woodland then the motorway again. Soon enough the guard announced that we were about to enter the Channel Tunnel and the passengers looked obediently to their windows in the hope of seeing – what? Shoals of brightly coloured fish swimming past aquarium glass? A tunnel under the sea is never quite as visually splendid as one hopes, but it is no less an achievement for that. Who designed the Channel Tunnel? No one knows the name. There are no more Brunels or Stephensons, and tunnels, by their very nature, never get the attention of great bridges, but still this was a great feat. I voiced the thought aloud; how tunnels were underrated and it was miraculous, really, to imagine that great mass of rock and water over our heads and yet to feel safe.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I don’t feel safe,’ said Albie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I sat back in my seat. Engineering – why hadn’t engineering interested my son?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Out into daylight, a militarised landscape of fences, concrete bunkers and escarpments, then the pleasant, uniform agricultural plain that stretches all the way to Paris. It is, of course, an illusion to imagine that the crossing of arbitrary boundaries on a map should correspond to variations in mood and temperament. A field is a field and a tree is a tree, but nevertheless this could only be France, and the air on the train took on a different quality, or seemed to, as French passengers emanated the satisfaction of returning home, and the rest of us the excitement of being officially ‘abroad’.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Here we are then! France!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And even Albie couldn’t find anything to disagree with there.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I fell asleep, neck cricked, jaw clenched, skull vibrating against glass, then awoke in the early afternoon as we entered the suburbs of Paris, Albie visibly perking up at the sight of graffiti and urban grime. I handed out A")]), _c('sub', [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("polypropylene wallets containing itineraries for the North European leg of our trip; hotel addresses, phone numbers and train times; and a loose breakdown of events and activities. ‘A guideline, rather than a strict schedule.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Albie turned the pages back and forth. ‘Why isn’t this laminated, Dad?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes, why isn’t it laminated?’ said Connie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Dad’s getting sloppy.’ My wife and son enjoyed heckling me. It gave them pleasure, so I smiled and played along, confident that they’d be grateful in the end.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Once off the train we felt revived, and I didn’t even mind the guitar case clunking against my knees, the coffee corrosion in my stomach and the edginess of that particular station. ‘Keep a close eye on your bags,’ I warned.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Any railway station, anywhere in the world,’ said Connie to Albie, ‘you can guarantee your father will tell you to keep a close eye on your bags.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Then the sky outside the Gare du Nord opening up, bright and blue, to greet us.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Are you excited?’ I asked my son as he climbed into the taxi.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’ve been to Paris before,’ he shrugged. Across the back of the seat, Connie caught my eye and winked and we set off, stopping and starting through the hard, unlovely kernel of the city towards the Seine, Connie and I sandwiching our son, hips pressed closer than we were used to, waiting for the commerce of the Grands Boulevards to give way to the dusty elegance of the Jardin des Tuileries, the lovely and ridiculous Louvre, the bridges across the Seine. Pont de la Concorde? Pont Royal? Unlike London, which has only two or perhaps three decent bridges, every crossing point of the Seine seems wonderful to me, clear views preserved on either side, and Connie and I peered greedily this way and that, following each other’s eyes while Albie looked down at his phone.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-7"
  }, [_vm._v("31.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on london bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We crossed London Bridge a little after two forty-five in the morning. The City was rather different in those years, squatter and less brazen than today, a model village Wall Street and very much alien territory to someone who rarely travelled further east than Tottenham Court Road. Now the place was deserted as if in advance of some impending disaster, and we walked past Monument, down Fenchurch Street, voices clear in the night air, and told the stories that we choose to tell when people are new.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Connie had recovered her powers of speech and told me more about her large, messy family, her mother an ex-hippy, skittish and boozy and emotional, her biological father long absent now, leaving her nothing but his surname. Which was? Moore. Connie Moore –")]), _vm._v(" "), _c('i', [_vm._v("a terrific name")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I thought,")]), _vm._v(" "), _c('i', [_vm._v("like a village in Ireland")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Her step-father could not have been more different, a Cypriot businessman who ran a number of questionable kebab shops in Wood Green and Walthamstow, and she was now an anomaly in her family: the arty, smart one. ‘I have three half-Cypriot brothers, little bulldogs they are; they all work in the business, and they have no idea what I do. Same as my dad – he’ll be watching telly and he’ll see a view of the Dales, or we’ll be on holiday and he’ll see a sunset or an olive tree and he’ll say – she slipped into an accent, she has always been very good at accents – ‘“Connie, you see that? Draw that! Draw it, quick!” Or he tries to commission me. “Draw your mother, she’s a beautiful lady, do a painting. I’ll pay.” To Kemal, that’s the supreme achievement of the artist, to draw eyes that look in the same direction.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Or hands.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Exactly. Hands. If you can fit all the fingers on, you’re Titian.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Can you draw hands?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Nope. I love him, though – Kemal – and my brothers, too. They dote on my mum and she sucks it all up. But I don’t see me in any of them, or in her either.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What about your father? Your biological—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She shuddered. ‘He left home when I was nine. I’m not really allowed to mention him because it sets my mum off. He was very handsome, I know that. Very charming, a musician. Ran off to Europe. He’s . . . out there . . . somewhere.’ She gestured towards the east. ‘Don’t really care,’ she said, and shrugged. ‘Change the subject. Ask me something else.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The biographies we give ourselves at such times are never neutral and the image she chose to present was of a rather solitary soul. She was not mawkish or self-pitying, not at all, but with the bravado gone, she seemed less confident, less self-assured, and I felt flattered by her honesty. I loved the conversation that we had that night, especially once she had stopped hallucinating. I had an infinite number of questions and would have been happy for her to recount her life in real time, would have been happy to walk on past Whitechapel and Limehouse into Essex and the estuary and on into the sea if she’d wanted to. And she was curious about me, too, something that I’d not experienced for some time. We talked about our parents and our siblings, our work and friends, our schools and childhoods, the implication being that we would need to know this information for the future.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Of course, after nearly a quarter of a century, the questions about our distant pasts have all been posed and we’re left with ‘how was your day?’ and ‘when will you be home?’ and ‘have you put the bins out?’ Our biographies involve each other so intrinsically now that we’re both on nearly every page. We know the answers because we were there, and so curiosity becomes hard to maintain; replaced, I suppose, by nostalgia.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-5"
  }, [_vm._v("32.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("many strange horses in our salty bedroom")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In planning our trip I had initially adopted a no-expense-spared attitude, until I calculated the full extent of this expense, at which point I adopted a comfortable-but-no-frills policy. It was this that brought us to the Hotel Bontemps, which may or may not translate as the Good Times Hotel, in the")]), _vm._v(" 7"), _c('span', {
    staticClass: "Superscript CharOverride-13"
  }, [_vm._v("th")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("arrondissement. Room")]), _vm._v(" 602 "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was clearly the result of a wager to determine the smallest space into which a double mattress can fit. Brassy and vulgar, the bed frame must have been assembled inside like a ship in a bottle. On closer examination, it also seemed our room was a repository for all of Europe’s spare pubic hair.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘All in all, I’d have preferred a chocolate on the pillow,’ said Connie, swatting them away.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Perhaps it’s fibres from the carpet,’ I suggested hopefully.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s everywhere! It’s like the chambermaid’s come in with a sack and")]), _vm._v(" "), _c('i', [_vm._v("strewn")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Suddenly weary, I fell backwards onto the bed, and Connie joined me, the covers crackling with static like a Van de Graaf Generator.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Why did we choose this place again?’ said Connie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You said it looked quirky on the website. The pictures made you laugh.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Not so funny now. Oh God. Sorry.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, it’s my fault. I should have looked harder.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Not your fault, Douglas.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I want everything to be")]), _vm._v(" "), _c('i', [_vm._v("right")]), _vm._v("."), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s fine. We’ll ask them to come and clean again.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What’s French for pubic hair?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I never learnt that. It never came up. Rarely.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’d say, “"), _c('i', [_vm._v("Nettoyer tous les cheval intimes, s’il vous plaît")]), _vm._v(".”’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘"), _c('i', [_vm._v("Cheveux")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".")]), _vm._v(" "), _c('i', [_vm._v("Cheval")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("means horse.’ She took my hand. ‘Oh well. We’re not going to be here much.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s a place to sleep.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Exactly. A place to sleep.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I sat upright. ‘Perhaps we should get going.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, let’s close our eyes. Here.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She took my hand, rested her head on my shoulder, our legs dangling over the edge as if on a riverbank. ‘Douglas?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Hm?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You know the . . . conversation.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You want to talk about that now?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, no, I was going to say, we’re in Paris, it’s a beautiful day, we’re all together as a family. Let’s not talk about it. Let’s wait until after the holiday.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Okay. Fine by me.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And so the condemned man, presented with his final meal, is reminded that at least the cheesecake is delicious.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We dozed. Fifteen minutes later a text from my son in the adjoining room woke us to say that he intended to ‘do his own thing’ until dinner. We sat up and stretched, brushed our teeth and left. At the reception desk, in French so riddled with errors, guesses and mispronunciation that it was almost a new language, I informed the desk clerk that I was destroyed but there were many strange horses in our salty bedroom, and we walked out into the Paris afternoon.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-9"
  }, [_vm._v("33.")]), _vm._v(" "), _c('i', [_vm._v("à la recherche du temps perdu")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Connie was still laughing as we crossed from the")]), _vm._v(" 7"), _c('span', {
    staticClass: "Superscript CharOverride-13"
  }, [_vm._v("th")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("to the")]), _vm._v(" 6"), _c('span', {
    staticClass: "Superscript CharOverride-13"
  }, [_vm._v("th")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on the sunny side of rue de Grenelle. ‘Where on earth did you learn it?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’ve sort of made it up myself. Why, what’s wrong with it?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The vocabulary, the accent, the syntax. You always get caught in these")]), _vm._v(" "), _c('i', [_vm._v("est-ce que")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("loops. “It is that it is possible that it is that the taxi to the hotel for to take us?”’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Maybe if I’d studied it, like you . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I didn’t study it! I learnt it from French people.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘From French boys. From nineteen-year-old French boys.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Exactly. I learnt “not so fast” and “I like you but as a friend”. I learnt “can I have a cigarette?” and “I promise I will write to you”.")]), _vm._v(" "), _c('i', [_vm._v("Ton cœur brisé se réparera rapidement")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Which means . . . ?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Your broken heart will soon mend.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Useful.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Useful when I was twenty-one. Not so much now,’ she said, and the remark lingered a moment as we reached St Germain.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When Connie and I first came here, in the days when we referred to ‘dirty weekends’ without irony, we were dizzy with Paris, drunk on the beauty of the city, drunk on being there together and also, more often than not, literally drunk. Paris was all so . . . Parisian. I was captivated by the wonderful wrongness of it all – the unfamiliar fonts, the brand names in the supermarket, the dimensions of the bricks and paving stones. Children, really quite small children, speaking fluent French! All that cheese and none of it Cheddar, and nuts in the salad. Look at the chairs in the Jardin du Luxembourg! So much more poised and elegant than the sag and slump of a deckchair. Baguettes! Or ‘French sticks’ as I called them then, to Connie’s amusement. We carried great armfuls of baguettes home on the plane, laughing as we crammed them into the overhead lockers.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But a branch of The Body Shop is much the same worldwide, and sometimes the Boulevard St Germain seems not that far from Oxford Street. Familiarity, globalisation, cheap travel, mere weariness had diluted our sense of foreign-ness. The city was more familiar than we wanted it to be and, as we walked in silence, it seemed some effort would be required to remind her of the fun we used to have, and could have in the future.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Pharmacies! What’s with all the pharmacies?’ I said, in my wry, observational tone. ‘How do they all survive? You’d think, from all the pharmacies, they’d be in a constant state of flu. We have phone shops, the French have pharmacies!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Still she said nothing. Crossing a side street, I noted the gutters were flowing with fast-moving water, sandbags blocking strategic drains. I had always been impressed by this particular innovation in urban hygiene, seemingly unique to Paris. ‘It’s like they’re rinsing out this immense bath,’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes, you say that every time we come here. That thing about pharmacies too.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Did I? I wasn’t aware of having said it before. ‘How many times have we been here now, d’you think?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I don’t know. Five, six.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘D’you think you could name them all?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Connie frowned at the thought. Both of our memories were deteriorating, and in recent years the effort required to recall a name or incident felt almost wearyingly physical, like clearing out an attic. Proper nouns were particularly elusive. Adverbs and adjectives would go next, until we were left with pronouns and imperative verbs. Eat! Walk! Sleep now! Eat! We passed a")]), _vm._v(" "), _c('i', [_vm._v("boulangerie")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Look – French sticks!’ I said, and nudged her. Connie looked blank. ‘When we first came to Paris I said, “let’s buy some French sticks” and you laughed and called me provincial. I said that’s what my mother used to call them. My dad thought they were barbaric. “It’s all crust!”’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That sounds like your father.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The first time you and I came to Paris, we bought about twenty and carried them back on the plane.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I remember. You told me off for nibbling at the ends.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’m sure I didn’t “tell you off”.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You said that’s what makes them go stale.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And we were silent again, turning north towards the Seine.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I wonder what Albie’s up to,’ said Connie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘He’s asleep, probably.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well that’s all right. He’s allowed.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Either that or he’s trying to work out why there are no mouldy mugs on the windowsill. He’s probably there now, burning cigarette holes in the curtains. Room service! Bring me three banana skins and an overflowing ashtray . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Douglas – this is precisely what we came here to avoid.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I know. I know.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And then she slowed and stopped. We were on rue Jacob, standing near a small, somewhat ramshackle hotel.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Look. It’s our hotel,’ she said, taking my arm.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You remember that.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That trip, I do. Which room was it?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Second floor, on the corner. The yellow curtains. There it is.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Connie put her head on my shoulder. ‘Perhaps we should have gone back to that hotel instead.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I thought about it. I thought it would have felt a little strange, with Albie there.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, he’d have liked it. You could have told him the story, he’s old enough now.’")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("34.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the hotel on rue jacob")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("It must have been eighteen years ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The anniversary of our daughter’s birth was fast approaching and, all too soon after, that other anniversary. I knew those days would be hard for Connie. Her grief, I had observed, tended to come in waves, and though the intervals between each crest were increasing, another storm was certainly due.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In my rather strained and bludgeoning way, I had been endeavouring to keep Connie buoyant with a kind of manic chirpiness; the perpetual warbling brightness of a morning DJ, endless loving phone calls from work, constant maudlin pawing and hugging and kisses on the top of her head. Tinny sentiment – Christ, no wonder she was blue – alternating with a private, secret wall-punching rage at the fact that I could do nothing to lift her spirits. Or indeed my own, because didn’t I have my own guilt and sadness?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Usually I might have expected her many loyal friends to step in where I had failed, but everywhere we looked babies and toddlers were being brandished, and we both found their proud display almost unbearable. In turn our presence seemed to make the new parents self-conscious and embarrassed. Connie had always been greatly loved, always popular and funny, but her unhappiness – people seemed affronted by it, especially when it quashed their own joy and pride. And so without any discussion we had withdrawn to our little world to sit quietly by ourselves. Walked, worked. Watched television in the evenings. Drank a little too much, perhaps, and for the wrong reason.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Of course, I had considered that another child might be the answer. Connie, I knew, longed to be pregnant again, and though we were fond and affectionate and, in some ways, closer than we’d been before, things were not easy. The stresses and strains of ‘trying for a baby’ have been rehearsed many, many times. In the shadow of what had happened – well, I won’t go into the details except to say that anger, guilt and grief are poor aphrodisiacs and our sex life, once perfectly happy, had taken on a rather dogged and dutiful air. It was not so much fun any more. Nothing was.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Paris, then. Perhaps Paris in the spring might be the answer. Hackneyed, I know, and I wince now to recall the lengths I went to in order to make that trip perfect; the first-class travel, the flowers and champagne ready in the hotel room, the chi-chi and expensive bistro I had reserved – all this in a largely pre-internet world where arranging such excursions involved PhD levels of research and nerve-shredding phone calls in a language that, as we’ve established, I neither spoke nor understood.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But the city was beautiful in early May, absurdly so, and we walked the streets in our best clothes and felt as if we were in a film. We spent the afternoon in the Rodin Museum, returned to the hotel and drank champagne while crammed into the tiny bathtub, then went woozily to dinner at a restaurant that I had previously reconnoitred, French but not cartoonishly so, tasteful, quiet. I don’t remember all that we said, but I do remember what we ate: a chicken with truffles under the skin that tasted like nothing we’d ever eaten before and wine, chosen purely by luck with a blind jabbing motion, that was so delicious as to be almost another drink entirely. Still in that corny film, we held hands across the table and then we went back to our hotel room on rue Jacob and made love.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Afterwards, on the edge of sleep, I was startled to notice that Connie was crying. The combination of sex and tears is a disconcerting one, and I asked, had I done something wrong?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘There’s nothing to be sorry for,’ she said, and, turning, I could see that she was laughing too. ‘Quite the opposite.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What’s funny?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Douglas, I think we’ve done it. In fact, I know we have.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Done what? What have we done?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’m pregnant. I know it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I know it too,’ I said, and we lay there and laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Of course, I should point out that there was no way of ‘knowing’ this. In fact, at that precise moment, it probably wasn’t even true, as the gametes take some time to make contact and form the zygote. Connie’s ‘sense’ of conception was an example of ‘confirmation bias’ – a desire to favour the evidence that confirms what we wish to believe. Many women claim to ‘know’ for sure that they are pregnant after sex. When, as in most cases, it transpires that they’re not, they immediately forget their prior certainty. In the rare cases that they’re right, they see this as confirmation of some supernatural or sixth sense. Hence confirmation bias.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Nevertheless, two weeks later a pregnancy test confirmed what we both already ‘knew’, and thirty-seven weeks after that Albert Samuel Petersen was welcomed into our world and chased our blues away.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-5"
  }, [_vm._v("35.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the little ray of sunshine")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - For crying out loud, Albie!")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - Why is it a problem?")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - But why don’t you want to come with us?")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - I want to do my own thing!")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - But I’ve booked the table for three people!")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - They won’t mind. Go with Mum. Stare into each other’s eyes, whatever.")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - What will you do?")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - Walk around, take photos. I might go and listen to some music.")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - Well, shall we come with you?")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - No, Dad, that is not a good idea. It’s the opposite of a good idea.")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - But wasn’t the point, wasn’t the whole point of this trip that we spend some time together as a family?")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - We spend loads of time together, every day!")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - Not in Paris!")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - How’s Paris different from home?")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - Well, if I have to answer that . . . Do you have any idea how much this trip is costing?")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - Actually, if you remember, I wanted to go to Ibiza.")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - You’re not going to Ibiza.")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - Okay, tell me how much this is costing, then. How much, tell me?")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - It doesn’t matter how much.")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - Well it obviously does, seeing as you keep bringing it up. Tell me how much, divide it by three, I can owe it to you.")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - I don’t mind how much, I just wanted – we wanted to spend time as a family.")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - You can see me tomorrow. Christ, Dad!")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - Albie!")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - I’ll see you in the morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - Fine. All right. See you in the morning. No lie-ins. Eight thirty sharp, or we’ll have to queue.")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - Dad, I promise you, at no point during this holiday will I relax.")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - Goodnight, Albie.")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   -")]), _vm._v(" "), _c('i', [_vm._v("Au revoir")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".")]), _vm._v(" "), _c('i', [_vm._v("A bientôt")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And Dad?")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_First"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - What?")])]), _vm._v(" "), _c('p', {
    staticClass: "UL1_Unordered_list_1_Last"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("   - I’m going to need some money.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("36.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("tripadvisor")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The restaurant where we’d eaten the famous chicken was closed for the annual exodus of the Parisians to the gîtes of the Loire, the Luberon, the Midi-Pyrénées. I’ve always had a grudging admiration for the chutzpah of this mass evacuation, a little like being invited to dinner only to find the hosts have gone out and left a tray of sandwiches. Instead we went to a local bistro that was so ‘Parisian’ that it resembled a set from a situation comedy; wine bottles barely visible under cascades of candle wax, canned Piaf, no inch of wall without a poster for Gauloises or Perrier.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘"), _c('i', [_vm._v("Pour moi, je voudrais pâté et puis l’onglet et aussi l’épinard. Et ma femme voudrait le salade et le morue, s’il vous plaît")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The beef, and the cod for madame. Certainly, sir.’ The waiter left.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘When I speak in French, why does everyone reply in English?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I think it’s because they suspect that you’re not a native French speaker.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But")]), _vm._v(" "), _c('i', [_vm._v("how do they know")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s a mystery to me,’ she laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘In the War, if I dropped behind enemy lines, how long before they cottoned on to the fact that I was English?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I suspect before the parachute opened.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Whereas you—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’d roam the country, undetected, blowing up bridges.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Seducing young mechanics from the Citroën garage.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She shook her head. ‘You have a distorted impression of my past. It wasn’t like that. Not entirely. And even when it was, it wasn’t much fun. I wasn’t very happy back then.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘So when did you become happy?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Douglas,’ she said, taking my hand by the fingertips, ‘don’t fish.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Thankfully we were now of an age where we no longer felt obliged to maintain a constant stream of conversation. In between courses, Connie read her novel and I consulted the guidebook to confirm the opening times and ticketing arrangements for the Louvre, and suggested some restaurants for the following day’s lunch and supper.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘We could just walk out and find somewhere,’ she said. ‘We could be spontaneous.’ Connie disapproved of guidebooks, always had. ‘Why would you want to have the same experience as everyone else? Why join the herd?’ And it was true that there was a preponderance of English and American voices amongst the customers around us, a sense from the staff that they were giving us what we wanted and expected.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But the food, when it came, was fine, with that excessive use of butter and salt that makes restaurant cooking so delicious, and we drank a little more wine than we should have, and enough cognac for me to forget, temporarily, my wife’s desire to move on. In fact, we were positively light-hearted by the time we made it back to the tiny room and, with the mild surprise that tended to accompany the act these days, we made love.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Other people’s sex lives are a little like other people’s holidays: you’re glad that they had fun but you weren’t there and don’t necessarily want to see the photos. At our age too much detail leads to a certain amount of mental whistling and staring at shoes, and there’s also the problem of vocabulary. Scientific terms, though clinically accurate, don’t really convey the heady dark intensity, etc., etc. and I’d like to avoid simile or metaphor – valley, orchid, garden, that kind of thing. Certainly I have no intention of using a whole load of swear words. So I won’t go into detail, except to say that it worked out pretty well for all concerned, with that pleasant sense of self-satisfaction, as if we’d discovered that we were still capable of performing a forward roll. Afterwards we lay in a tangle of limbs.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘A tangle of limbs’. Where did I get that from? Perhaps one of the novels that Connie encourages me to read.")]), _vm._v(" "), _c('i', [_vm._v("They fell asleep in a tangle of limbs")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Like a pair of honeymooners,’ said Connie, her face very close, laughing in that way she has, eyes wrinkling, grinning, and I was suddenly hit by a wave of unspeakable sadness.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘This has always been all right, hasn’t it?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘This . . . side of our relationship.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It has. You know that. Why?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I just realised, one night we’re going to do this for the last time, that’s all.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Oh, Douglas,’ she laughed and pressed her face into the pillow. ‘Well, that’s taken all the fun out of it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The thought just occurred to me.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Douglas, everyone has that eventually.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I know. But this’ll be a little sooner than anticipated.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She kissed me, sliding her hand behind my neck in that way she has. ‘You don’t need to worry. I’m pretty sure that wasn’t quite the last time.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well that’s something, I suppose.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’ll tell you when it’s the last time. I’ll toll a bell. I’ll wear a shroud and we’ll play a slow funeral march.’ We kissed. ‘I promise, when it’s the last time, you will know.’")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-5"
  }, [_vm._v("37.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("first time")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The first time we made love was a very different kettle of fish. Again, I won’t get into specifics, but if I had to use a single word to sum it up, the word would be ‘terrific’, and though Connie would undoubtedly find a better word, I like to think she would agree. Which might surprise people, I suppose. I don’t want to blow my own trumpet, but I’ve always been better at that kind of thing than others might expect. I’m keen, for one thing, and at that time I had also been playing a great deal of badminton, so was in pretty good shape. Also, it’s important to remember that Connie was still under the influence of certain artificial stimulants, and I’m prepared to accept that was also a factor. There was Chemistry between us, if you like. I once pointed out to Connie that she wouldn’t have taken me home if she’d been sober. Rather than deny it, she laughed. ‘You’re probably right,’ she said. ‘Another reason to Just Say No.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We arrived at the unassuming terraced house behind Whitechapel Road just before four in the morning. Apparently this area has since become fashionable, and perhaps Connie and her friends planted that seed, but at the time this was uncharted territory for someone like me. We were a long way from the All Bar Ones and Pizza Expresses of Hammersmith, Putney and Battersea, the somewhat suburban boroughs where many of my friends and colleagues lived.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s mainly Bangladeshi, with a little bit of old East End. I love it. It’s what the city used to be, before the yuppies moved in.’ She opened the door. Was I meant to come in?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well . . . I’d better be off, I suppose,’ I said with a shrug, and Connie laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s nearly four!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I thought I’d walk.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Back to Balham? Don’t be daft, come in.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘There’ll be a night bus, I’m sure. If I can get to Trafalgar Square, I can change and get the N")]), _c('sub', [_vm._v("77")]), _vm._v(" . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘For Christ’s sake, Douglas,’ she laughed. ‘For a PhD, you’re extremely dim.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I didn’t want to assume anything.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘To assume,’ she said, ‘makes an ass of u and me.’ Then she leant forward, put her hand behind my neck and kissed me with some force. And that – that was terrific too.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("38.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("lime, vodka, chewing gum")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The house was an organised mess. ‘Curated’ is the word Connie would use, with every inch of wall covered with reproductions, postcards, posters for bands and clubs, photographs and sketches. The furniture was what might be called ‘eclectic’: a church pew, school chairs, an immense pale leather G Plan sofa partially buried beneath discarded clothes, magazines, books, newspapers. I saw a violin, a bass guitar, a stuffed fox.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’m having vodka!’ shouted Connie from the kitchen – I didn’t dare to wonder what the kitchen was like – ‘But there’s no ice. Would you like vodka?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Just a small one,’ I replied. She entered with the drinks and I noticed that she had reapplied lipstick somewhere along the way, and that made my heart sing too.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘As you can see, the cleaners have just been.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I took my glass. ‘There’s fresh lime in this.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I know! Sophisticated,’ she said, biting the slice. ‘Club Tropicana.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Are any of these paintings yours?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, I keep those safely locked away.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’d love to see something. Your work.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Maybe tomorrow.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('i', [_vm._v("Tomorrow?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Where’s Fran?’ She had told me all about Fran, her housemate, who, like all housemates through the ages, was ‘completely mad’.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘She’s at her boyfriend’s.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Oh. Okay.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s just you and me.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Okay. And how are you feeling?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘A little better. I’m sorry for freaking out like that. I shouldn’t have taken that pill, it was a bad idea. But I appreciate you staying with me. I needed . . . a calming presence.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘And now?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Now, now I feel . . . perfectly fine.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We smiled. ‘So,’ I said, ‘am I sleeping in Fran’s bed?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Good God, I bloody hope not.’ She took my hand and we kissed again. She tasted of lime and chewing gum. In fact the gum was still in her mouth, which would have thrown me at any other time.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Sorry, that is disgusting,’ she laughed, removing it, ‘us kicking that around in there.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Don’t mind,’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She stuck the gum on the doorframe. I felt her hand on my back, found my hand on her thigh, on top of the dress then beneath it. I stopped to catch my breath. ‘I thought you said nothing was going to happen?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I changed my mind. You changed it for me.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Was it because of the lemon battery thing?’ I said, and she laughed while we kissed. Oh yes, I was quite the wisecracker.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘My bedroom’s a disaster area,’ she said, breaking away. ‘Literally and figuratively.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I don’t care,’ I said, and followed her upstairs.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Do I sound uncharacteristically suave in all of this? Do I sound aloof, nonchalant? The truth is that my heart felt like a fist trying to punch its way through my rib-cage – not from the excitement of it all, though it was thrilling, but from a sense that finally, finally something good was about to happen to me. I felt the proximity of change, and I had wanted more than anything for something in my life to change. Is it still possible to feel like that, I wonder? Or does it only happen to us once?")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("39.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("a brief history of art")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out_SA"
  }, [_vm._v("Cave paintings. Clay then bronze statues. Then for about 1,400 years, people painted nothing except bold but rudimentary pictures of either the Virgin Mary and Child or the Crucifixion. Some bright spark realised that things in the distance looked smaller and the pictures of the Virgin Mary and the Crucifixion improved hugely. Suddenly everyone was very good at hands and facial expression and now the statues were in marble. Fat cherubs started appearing, while elsewhere there was a craze for domestic interiors and women standing by windows doing needlework. Dead pheasants and bunches of grapes and lots of detail. Cherubs disappeared and instead there were fanciful, idealised landscapes, then portraits of aristocrats on horseback, then huge canvases of battles and shipwrecks. Then it was back to women lying on sofas or getting out of the bath, murkier this time, less detailed, then a great many wine bottles and apples, then ballet dancers. Paintings developed a certain splodginess – critical term – so that they barely resembled what they were meant to be. Someone signed a urinal, and it all went mad. Neat squares of primary colour were followed by great blocks of emulsion, then soup cans, then someone picked up a video camera, someone else poured concrete, and the whole thing became hopelessly fractured into a kind of confusing, anything-goes free for all.")]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-9"
  }, [_vm._v("40.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the philistine")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Such was my understanding of the history of art – its ‘narrative’, I ought to call it – until I met my wife. It is barely more sophisticated now, though I’ve picked up a few things along the way, enough to get by, so that my art appreciation is almost on a par with my French. In the early days of our relationship Connie was quite evangelical and bought me several books, second-hand editions because we were in our happy-but-poor phase. Gombrich’s")]), _vm._v(" "), _c('i', [_vm._v("The Story of Art")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("was one,")]), _vm._v(" "), _c('i', [_vm._v("The Shock of the New")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("another, given specifically to stop me tutting at modern art. Well, in the first flush of love, if someone tells you to read something then you damn well read it, and they’re terrific books, both of them, though I’ve retained almost nothing of their contents. Perhaps I should have given Connie a basic primer in organic chemistry in return, but she never expressed an interest.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Still – and I’d hesitate to confess this to Connie, though I think she knows – I’ve always felt a little at a loss with art, as if a piece of me is missing, or was never there. I can appreciate draughtsmanship and deft choice of colour, I understand the social and historical context, but despite all my best efforts my responses seem to me fundamentally shallow. I don’t quite know what to say or, indeed, feel. In portraiture I look for people that I recognise – ‘Look, it’s Uncle Tony’ – or for the faces of film stars. The Madame Tussaud’s school of art appreciation. In realist works I look for detail; ‘Look at the eyelashes!’ I say, in idiotic admiration at the fineness of the brush. ‘Look at the reflection in his eye!’ In abstract art I look for colour – ‘I love the blue’ – as if the works of Rothko and Mondrian were little more than immense paint charts. I understand the superficial thrill of seeing the object in the flesh, so to speak; the sightseeing approach that lumps together the Grand Canyon, the Taj Mahal and the Sistine Chapel as items to tick off. I understand rarity and uniqueness, the ‘how much?’ school of criticism.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And of course I can see beauty. In my work, I see it all the time: the symmetrical cleavage of a fertilised frog egg, the stained stem cells of a zebrafish embryo or an electron micrograph of")]), _vm._v(" "), _c('i', [_vm._v("Arabidopsis")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the thale cress flower; and I can see the same forms and patterns, the same pleasing proportion and symmetry in paintings. But are they the right paintings? Do I have taste? Am I missing something? It’s subjective, of course, and there are no right answers, but in a gallery I always have that feeling that the security guards are waiting to bundle me out of the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("My wife and son have few such insecurities. Certainly they weren’t on display in the Italian gallery of the Louvre, where Albie and Connie were playing that game of seeing who could stare at a painting the longest. In this case it was a fresco by Botticelli, cracked and faded and a lovely thing, but was there really so much to see? I waited while they drank it all in, the brush strokes, the interplay of light and dark, all the things I’d missed. Eventually there was movement, and we strolled on past endless varieties of crucifixions and nativities, assorted martyrs whipped or pierced with arrows, a nonchalant saint with a sword embedded in his head, a scene of Mary – it’s usually Mary – recoiling from an angel that had left a vapour trail behind him. ‘Braccesco, apparently,’ I said. ‘Jet-powered angel!’ as if it meant something, and we moved on.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We passed a terrific battle scene by someone called Uccello, soldiers clustered together into a black porcupine, the cracks and tears on the canvas adding to its grandeur in a strange kind of way. Then in the grand central corridor my eye was drawn to a portrait of a bearded man whose face, on closer inspection, was composed of apples, mushrooms, grapes, a pumpkin, his nose a fat ripe pear")]), _vm._v(". ‘"), _c('i', [_vm._v("L’Automne")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("by Arcimboldo. Look, Albie, his face is made up of fruit and vegetables!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Kitsch,’ said Albie, presenting with his eyes the award for Most Banal Remark Ever Made in an Art Gallery. Perhaps this was why those museum audio-guides had become so popular; a reassuring voice in your ear, telling you what to think and feel.")]), _vm._v(" "), _c('i', [_vm._v("Look to your left, take note, please observe")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(";")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("how terrific it would be to carry that voice with you always, out of the museum and throughout all of life.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We moved on. There was a lovely fuzzy da Vinci, as if seen through smeary spectacles, of two women cooing over baby Jesus, but this didn’t seem to interest Connie and Albie, and I couldn’t help but notice that the more famous and familiar a work of art, the less time they spent looking at it. Certainly they had no interest in the")]), _vm._v(" "), _c('i', [_vm._v("Mona Lisa")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the Hard Rock Cafe of Renaissance art, hanging regally between signs that warned of pickpockets in an immense, high-ceilinged room while other neglected canvases glared. Even early in the day a crowd had gathered, and were posing with that particular ‘can’t believe it!’ smile that people have when their arm is around a celebrity’s shoulder. ‘Albie! Albie, can you take a photo of me and your mum . . .’ I said, but they’d already snubbed the Giaconda in favour of a small canvas on the other side of the")]), _vm._v(" "), _c('i', [_vm._v("Mona Lisa")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("’s wall – a murky Titian, in the shadows both literally and figuratively, of two large, naked women giving a recorder concert. They stared and stared and I wondered, what was I meant to take from this? What were they seeing? Once again I was struck by the power of great art to make me feel excluded.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Back in the main corridor, Albie paused before a little portrait by Piero della Francesca, then produced a small, expensive leather-bound sketchbook and began copying it in charcoal, and my heart sank. There may well be a scientific paper to be written on why walking in an art gallery is so much more exhausting than, say, climbing Helvellyn. My guess is that it is something to do with the energy required to hold muscles in tension, combined with the mental exertion of wondering what to say. Whatever the reason, I sank exhausted onto the leather couch and watched Connie instead, the way her skirt stretched across her bottom, the movement of her hands, her neck as she raised her eyes to a canvas. That was art, right there. That was beauty.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She looked at me, smiled and crossed the room, touched her cheek against mine. ‘Tired, old man? That’ll be last night.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Too much art. I wish I knew which ones to look at.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Thumbs up, thumbs down?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I wish they’d just point out the good ones.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Maybe the “good ones” aren’t the same for everyone.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I never know what to say.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You don’t have to say anything. Just respond. Feel.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She pulled me to my feet and we hiked on through this vast, regal storeroom, past ancient glass, marble and bronze, into the French nineteenth century.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-5"
  }, [_vm._v("41.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("art appreciation")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Sexual nostalgia is a vice best indulged in private, but suffice to say that our first weekend together was quite an eye-opener. Those February days were dark and squally and we were reluctant to leave the little house in Whitechapel. Certainly there was no question of my going to the lab on Saturday, and instead we slept, watched films and talked, hurrying out at night to pick up Indian takeaway from a restaurant where Connie was well known and greeted by the entire staff, who showered us with complimentary poppadums and those little tubs of raw onion that no one really wants.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘And who is this handsome young man?’ asked the head waiter.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘He’s my hostage,’ said Connie. ‘He keeps trying to make a run for it, but I won’t let him get away.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s true,’ I said, then, while she ordered, wrote ‘Help me!’ on a napkin and held it up, and they all laughed, Connie too, and I felt immense warmth and affection, and also a little envy, for the vibrancy of someone else’s life.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Sunday morning had a melancholy air, like the last day of a wonderful holiday, and we stepped out to the corner shop for newspapers and bacon, then sought refuge in her bed. Of course it wasn’t all sex, sex, sex, though largely it was. There was conversation, too, and Connie played me her favourite records, and she slept a great deal, at seemingly random times of day and night, and in those hours I would extricate myself from the mess of blankets, bedspreads and quilts, and explore.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The bedroom was murky and under-lit, the skirting boards concealed behind hundreds of books: volumes of fine art, vintage")]), _vm._v(" "), _c('i', [_vm._v("Rupert")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("annuals, classic novels and reference works. Her clothes hung on a bare rail – no wardrobe – an arrangement that struck me as almost unspeakably cool, and I secretly longed to work my way through the rail, insisting that she try things on. There were portfolios containing her pictures, too, and although she had banned me from examining these, I untied the ribbons and took a look while she slept.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("They were portraits, mainly, some stylised with facial features slightly askew, some more realistic, the contours drawn on to the skin with fine ink lines, like a three-dimensional graph. Eyes downcast, faces turned towards the floor. Her work was more accessible than I had expected, conventional even, and though I found them rather gloomy, I liked them very, very much. But then I’d have liked a shopping list as long as it was her shopping list.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Downstairs, the living room was stylishly ramshackle and scrappy, as if a great deal of thought had gone into the huge pile of children’s board games, the Chinese restaurant sign, the ancient filing cabinets and seventies bric-a-brac. Mustard thick-pile carpet gave way to the sticky tiles of the kitchen, dominated by an immense jukebox containing the same mystifying mix of ‘good’ and ‘bad’ taste: obscure electronic and punk bands muddled in with seventies novelty records, songs by Frank Zappa, Tom Waits and Talking Heads alongside ABBA and AC/DC and the Jackson")]), _vm._v(" 5.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Clearly I was out of my depth. Irony, was that the difference? My own cultural tastes were fairly unsophisticated but at least they were sincere, and how was I to tell the good kind of bad taste from the bad kind of bad taste? How did one listen to a piece of music ironically? How did one adjust one’s ears? An ABBA album in my hands would be a source of derision, in Connie’s a sign of cool, and yet it was still the same verse-chorus-verse. Was the vinyl imbued with different qualities, depending on who played it? I had, for instance, been a long-time advocate of the music of Billy Joel, particularly his early- to middle-period albums, and this had been the cause of some mockery from the hipper, edgier biochemists. Bland, they called him, middle-of-the-road and safe. Yet here on Connie’s jukebox was Barry Manilow, a far less sophisticated artist. What did Connie do to ‘Mandy’ that somehow rendered it ‘cool’?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The same applied to décor. The paraphernalia that gave Connie and her flatmate art-school credibility – the medical school skeleton, parts of mannequins, the stuffed animals – would have made me look like a serial killer. I dreaded the day that Connie would see my Balham flat – the flat-pack furniture and bare magnolia walls, the comatose yucca plant, the all-too-prominent television. Yet I also dreaded the idea that she might not make it that far.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("42.")]), _vm._v(" "), _c('i', [_vm._v("cartes postales")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Of course, she’d be mortified to be reminded of all this. Ironic bad taste is harder to pull off in a comfortable family home, where a phone that looks like a lobster is unlikely to raise much of a smile. That baton has been passed to Albie, forever on the lookout for interesting road signs or the disembodied heads of dolls.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("What they both still share, though, is a fetish for postcards. Albie has plastered his bedroom with them, like very expensive wallpaper, and so we dutifully found ourselves in the Louvre gift shop, both of them compiling great stacks of")]), _vm._v(" "), _c('i', [_vm._v("cartes postales")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I tried to join in the game, selecting a card from the racks,")]), _vm._v(" "), _c('i', [_vm._v("The Raft of the Medusa")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("by Géricault, a painting that I’d enjoyed seeing in the flesh, so to speak, because of its fantastic drama. It hung in ‘Large French Paintings’, alongside canvases the size of a family home, depicting battles in the ancient world, cities in flame, the coronation of Napoleon, the retreat from Moscow; the Ridley Scott school of art, full of effects, strong lighting and a cast of thousands. The three of us had stood before the immense")]), _vm._v(" "), _c('i', [_vm._v("Medusa")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("; ‘I wonder how long it took to paint . . .’ and ‘Look at this man here. He’s in trouble!’ and ‘I wonder how we’d manage in that situation?’ were my observations. I showed the postcard to Albie, the power of the image somewhat diminished at")]), _vm._v(" 4"), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("x")]), _vm._v("6 "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("inches, and he shrugged and gave me his pile of chosen cards, and Connie’s too, and off I went to pay for them.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("43.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("postcards")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In Whitechapel, postcards covered the whole of the kitchen wall, two or three thick at some points, jumbled in with Polaroids of her art-school friends. There were a lot of punk-ish girls posing with cigarettes, but I was also struck by the number of handsome young men on display, usually with Connie or Fran draped adoringly around them, pouting and blowing kisses. Men in army fatigues or paint-stained overalls; men with eccentric facial hair; intimidating, unsmiling men, and one in particular, a shaven-headed thug with very blue eyes, a cigarette dangling from his mouth and a bottle of beer in his hand. An action-movie mercenary staring at the camera while Connie clung to him or kissed the top of his stubbled head or pressed her cheek to his; impossible to ignore the infatuation in her, awful to see it too.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I should probably take those down,’ she said, behind me.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Is that . . . ?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That’s Angelo. My ex.’")]), _vm._v(" "), _c('i', [_vm._v("Angelo")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Even his name was a blow. How could a Douglas compete with an Angelo? ‘He’s very handsome.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘He is. He’s also not important to me any more. Like I said, I’m going to take them down.’ With a little tug she tore the most prominent photo from the wall and placed it in the pocket of her dressing gown. Not in the bin, but in her breast pocket, next to – well, her breast.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("There was a moment’s silence. We had made it to Sunday afternoon, a time of the week that always threatens to tip over into an almost unbearable gloom, and I wanted very much to leave on a positive note. ‘Perhaps I’d better go.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The hostage is escaping.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘If I make a run for it, will you stop me?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I don’t know. Do you want to be stopped?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I wouldn’t mind.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Okay,’ she said. ‘Then let’s go back to bed.’")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-9"
  }, [_vm._v("44.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("romantic comedy behaviour")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Excruciating, isn’t it? But that was how we spoke to each other once upon a time. It was a new voice for me. Something had changed and I had no doubt, as I finally stumbled from the house on Sunday night, aching and comically dishevelled, heading back to Balham on empty trains, that I was in love with Connie Moore.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("This was by no means a cause for celebration. It had sometimes puzzled me why falling in love should be regarded as some wondrous event, accompanied by soaring strings, when it so often ended in humiliation, despair or acts of awful cruelty. Given my past experience, the theme from")]), _vm._v(" "), _c('i', [_vm._v("Jaws")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("would have been more fitting, the violins from")]), _vm._v(" "), _c('i', [_vm._v("Psycho")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Of course I had been involved in two or three ‘serious’ relationships, each lasting slightly longer than the shelf-life of a half-dozen eggs, but while there had been moments of happiness and affection, no hearts had been set aflame as yet. And yes, I had ‘dated’ too, a series of unsuccessful job interviews for a post I didn’t really want, the meetings largely taking place in cinemas because there would be less obligation to speak. Often I was home by a quarter to ten, queasy from a large bag of Maltesers. Love and desire played little part in these dates. Embarrassment and self-consciousness were the key emotions, discomfort increasing exponentially at each encounter until one or other of us cracked and blurted out a standard-form ‘let’s be friends’, after which we’d part, sometimes at a brisk run. As to romantic love, the real thing, I had been stricken once before, but reminiscing about Liza Godwin was like expecting the")]), _vm._v(" "), _c('i', [_vm._v("Titanic")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("’s captain to fondly recall the iceberg.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We met on our first day at university, where she was studying modern languages, and were immediately great friends, inseparable, right up until I committed the error of making a pass at a sherry party that had got out of hand. She responded to my attempted kiss by ducking, quite low, bending from the knees and hurrying away, like someone avoiding the blades of a helicopter. This cooled our friendship and soon I was resorting to notes and letters posted under the door of her room in our halls of residence. Once a mutual pleasure, our proximity became so problematic to Liza that she moved to different accommodation, and I would telephone her there, late at night, not entirely sober, because what could be more charming and devil-may-care, what could melt a woman’s heart like a deranged phone call after midnight?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To her credit, Liza remained sympathetic and understanding of my feelings, right up until the point where several members of the rugby team suggested that I might consider ‘backing off’ for a while. Their intervention removed all ambiguity and, in the battle between love and violence, violence won. I never spoke to Liza Godwin again. Still, I’m afraid I took it all very badly. I hesitate to use the word ‘overdose’. A disregard for the safety guidelines would be more accurate. The aspirins were soluble and the volume of water required to dissolve, I think, five of them, was considerable and meant that I woke up with a desperate need for the bathroom and a perfectly clear head. Looking back, it all seems very uncharacteristic; embarrassing, too, my one moment of adolescent melodrama. What was I hoping to achieve? It was hardly a ‘cry for help’; I would have been embarrassed to make that much noise. ‘A cough for help’, perhaps that was what it was. A clearing of the throat.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("So there was good reason to fear a recurrence of a condition whose symptoms were insomnia, dizziness and confusion followed by depression and a broken heart. As the Northern Line train rattled into Balham, the doubts were already crowding in. It wasn’t even as if Connie’s decision had been the product of a rational mind, and the passion she had felt at three a.m. seemed unlikely to survive until the following Thursday, our second date, when we would be sober and self-conscious. Then there was Angelo to contend with, lurking even now in the pocket of her dressing gown nearest to her breast. Nothing could be taken for granted. Winning Connie Moore, keeping Connie Moore would be a challenge that would continue right up until an afternoon in Paris . . .")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("45.")]), _vm._v(" "), _c('i', [_vm._v("pelouse interdite")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(". . . where we slept off our lunch in the Jardin du Luxembourg, a park so elegant and groomed that I always half expect to be asked to remove my shoes. Lying on the grass is only permitted in a cramped strip at its southern end, sunbathers clinging to it as if to the hull of an overturned cruise ship. Our mouths were sticky from red wine and salty duck and we took it in turns to quench our thirsts with briny sparkling water that had long since ceased to sparkle.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘How do French people do it?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Do what?’ Connie’s head was resting on the pillow of my stomach.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Drink wine at lunchtime. I feel like I’ve been anaesthetised.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I don’t know if they do any more. I think that’s just us tourists.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("To our left, four Italian language students were hunched over Chinese takeaway in plastic trays, the syrup and vinegar smell hanging in the hot, still air. To our right, three skinny Russian boys were listening to Slavic hip-hop on the speaker of their mobile phone, running their hands over their shaved heads and intermittently howling like wolves.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘City of Proust,’ sighed Connie, ‘the city of Truffaut and Piaf.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You are having a nice time, aren’t you?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Very much so.’ She reached behind her, searching for my hand, but the effort was too great and her arm dropped back.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You think Albie’s happy?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Posing around Paris at his father’s expense? Of course he is. Remember it’s against his principles to show happiness.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Where does he keep disappearing off to all the time?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Maybe he has friends here.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Which friends? He doesn’t have friends in France.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Friends means something different now to what it meant in our day.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘In what way?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well, he goes online and writes, “hey, I’m in Paris” and someone else says, “I’m in Paris too!” or someone says, “my friend lives in Paris, you should meet up.” And so he does.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Sounds terrifying.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I know. All those new people, all that spontaneity.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It was hard enough having a pen-pal.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She rolled on to her front, latching on to something new. ‘Douglas, you had a pen-pal?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Günther from Düsseldorf. He came to stay, but it wasn’t a success. Couldn’t eat my mother’s food. He was visibly wasting away, and I was terrified we’d get in trouble for sending back this malnourished child. In the end my father practically tied him to a chair until he’d eaten his liver and onions.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Such golden memories you have. Did you get invited to Düsseldorf?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, strangely enough!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You should find the address, track him down.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Maybe I will. Did you have a pen-pal?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘French girl. Elodie. She wore an unnecessary bra and taught me how to roll cigarettes.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘So it")]), _vm._v(" "), _c('i', [_vm._v("was")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("educational.’ Connie turned again, and closed her eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It would be nice to bump into him, though,’ I said. ‘Every now and then.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Günther?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Our son.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘We’re seeing him tonight. I’ve fixed it. Now let me sleep.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We dozed to the lulling sound of Russian hip-hop in which, interestingly, only the profanities remained in English, presumably so as to offend the widest possible international audience. In the late afternoon, sitting and yawning, Connie suggested we rent bicycles. Still a little drunk, we rode the municipal machines, unwieldy as wheelbarrows, along whichever street we liked the look of.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Where are we going?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘We’re deliberately getting lost!’ she shouted. ‘No guidebooks, no maps allowed.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And despite being too foggy to ride a heavy bicycle on the wrong side of the road, I adopted a devil-may-care, freewheeling attitude, knees clipping wing mirrors, ignoring the waved fists of the taxi-drivers as I smiled, smiled, smiled.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-9"
  }, [_vm._v("46.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("françois truffaut")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The warm feelings continued into the evening. Connie had spotted an open-air cinema screen in an urban park not far from Place d’Italie and decided that we would go and watch a movie there. A stolen bedcover from the Good Times Hotel was our picnic blanket; there was rosé wine, bread and cheese, the evening was warm and clear. Even Albie seemed pleased to be there.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Will it be in French?’ he asked, as we established our base in front of the screen.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Albie, don’t worry, you’ll understand. Trust me.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The film was called")]), _vm._v(" "), _c('i', [_vm._v("Les Quatre Cents Coups")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("or")]), _vm._v(" "), _c('i', [_vm._v("The 400 Blows")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("and I recommend it. My own taste in cinema tends towards the thriller or science-fiction/fantasy genres, but despite the lack of actual blows it was very entertaining. The film concerns the misadventures of an intelligent but irresponsible young man called Antoine who ends up in trouble with the law. His amiable father, who is being betrayed by the mother, loses patience with young Antoine, and the boy is sent to a sort of borstal. Escaping, he runs towards the sea – he has never seen the sea before – and then, well, the film just stops with the young man looking into the camera in a challenging, almost accusatory way.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In plot terms it was no")]), _vm._v(" "), _c('i', [_vm._v("Bourne Identity")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("but I found myself enjoying it nonetheless. It was a film about poetry, rebellion, the elation and confusion of youth – not")]), _vm._v(" "), _c('i', [_vm._v("my")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("youth necessarily, other people’s youth – and it had a profound effect on Albie, who was so engaged in the film that he temporarily forgot to drink excessively, and knelt erect with his hands placed on his thighs in a pose that I’d last seen on the gym mats at his primary school.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The sky darkened and the projection came into sharper focus, swallows darting across the screen like specks on the celluloid – or perhaps they were bats, or both – and Albie sat there, identifying violently with the character despite, I think it’s fair to say, having had a pretty stable childhood. Every now and then I turned to see his profile flashing white in the light of the monochrome screen, and I found myself feeling a terrific fondness for him, for both of them, for us, the Petersens, a little pulse of love and affection, a conviction that our marriage, our family, was not so bad, was better than most, and that we would survive.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Anyway, it was all very atmospheric and congenial and all too soon it was over. The final image froze, Antoine Doinel was giving us that look from the screen, and Albie was rubbing his cheeks with the heels of his hands as if cramming the tears back into his eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That,’ he declared, ‘was the greatest fucking film I have ever seen in my life.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Albie, is that language really necessary?’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘And the photography was amazing!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes, I liked the photography too,’ I chipped in hopefully, but Albie and his mother were deep in an embrace, Albie squeezing her as they both laughed, and then he was running off into the summer night and Connie and I, too drunk to risk the bicycles again, held hands and walked home through the")]), _vm._v(" 13"), _c('sup', [_vm._v("th")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _vm._v(" 5"), _c('sup', [_vm._v("th")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _vm._v(" 6"), _c('sup', [_vm._v("th")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the")]), _vm._v(" 7"), _c('sup', [_vm._v("th")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("love’s young dream.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("47.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the intrinsic difficulty of the second date")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Despite my PhD, the intricate algorithm of what to do on a second date had entirely defeated me. Each restaurant seemed either too formal and ostentatious or too casual and downmarket. It was late February, so too cold for Hyde Park, and my usual preferred option, the cinema, wasn’t right either. We wouldn’t be able to talk at the cinema. I wouldn’t be able to see her.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("We arranged to meet on the campus quad outside the laboratory where I was working on my post-doc. Since leaving art school, Connie had been employed four days a week at a commercial gallery in St James’s. She had railed against the place – the lousy art, the customers with more money than taste – but it enabled her to pay the rent while she worked on her own paintings in the small east London studio she shared with friends – a collective was the term they used – each of them waiting for their breakthrough. As a career plan, it all sounded hopelessly unstructured to me, but the St James gallery at least meant she could pay her rent and eat. In a stammering phone call, I had instructed her on the bus routes open to her, the precise workings of the 19, the 22, the 38. ‘Douglas, I grew up in London,’ she had told me, ‘I know how to catch the bus. I’ll see you at six thirty.’ By six twenty-two I was beneath the clock tower, staring at the latest "), _c('i', [_vm._v("Biochemist")]), _vm._v(", eyes sliding across the page without gaining purchase, still staring at six forty, hearing her before I saw her; the tap-tap of high heels was not a common sound on this part of the campus.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("In our digital age we now have the electronic means to summon up a face more or less at will. Back then faces were like phone numbers; you tried to memorise the important ones. But my mental snapshots of the previous weekend had begun to fade. Chaste and sober on a squally, gun-metal weekday, would I be disappointed?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Not a chance. The reality, when I saw her, far exceeded my memories: the wonderful face framed by the raised collar of a long black overcoat; some sort of old-fashioned dress beneath it, rust red; carefully made-up; dark eyes, lips to match her dress. The scampi platter at the Rat and Parrot had ceased to be an option.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We kissed a little awkwardly, an earlobe for me, hair for her. ‘You look very glamorous.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘This? Oh, I have to wear this for work,’ she said, as if to say")]), _vm._v(" "), _c('i', [_vm._v("this isn’t meant for you")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("; eight seconds gone and already a botched kiss, an imagined slight. The evening stretched before us like a tightrope across some vast canyon. To mark the importance of the occasion, I was wearing my best jacket, raffish chocolate brown corduroy, and a knitted tie, dark plum. Her hand travelled to the knot and adjusted it.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Very nice. Good God, you actually have a pen in your top pocket.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘As a scientist, I have to. It’s my uniform.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She smiled. ‘Is this where you work?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Over there, in the lab.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘And the fruit flies?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘They’re inside. Do you want to come and see?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Am I allowed? I always assumed all labs were top secret.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Only in films.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She grabbed my arms with both hands. ‘Then I have to see the fruit flies!’")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-9"
  }, [_vm._v("48.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("insectory")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She stared at the clouds of flies, her face close to the muslin, quite bewitched. It was as if I’d taken her to the unicorn enclosure.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Why fruit flies? Why not ants or beetles or stick insects?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Whether her interest was genuine, exaggerated or feigned, I couldn’t say. Perhaps she viewed the insectory as some kind of art installation; I know such things exist. Whatever the reason, ‘why fruit flies?’ was the kind of question that I longed to hear, and I explained about the fast breeding, the low upkeep, the conspicuous phenotypes.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Which are . . . ?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Observable characteristics, traits, manifestations of the genotype and the environment. In fruit flies, shorter wings, eye pigmentation, changes in the genital architecture.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘“Genital architecture”. That’s the name of my band.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It means that you can see indications of mutation in a very short time. Fruit flies are evolution in action. That’s why we love them.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Evolution in action. And what do you do when you want to examine their genital architecture? Please, please don’t tell me you kill them all?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Usually we knock them unconscious.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘With tiny truncheons?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘With carbon dioxide. Then after a while they stumble back onto their feet and get on with having sex.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘My typical weekend.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A moment passed.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘So can I keep one? I want . . .’ She pressed a finger to the glass ‘. . . that one there.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘They’re not goldfish at the fairground. They’re tools of science.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But look – they really like me!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Perhaps it’s because you smell of old bananas!’ Another moment passed. ‘You don’t smell of old bananas. I’m sorry, I don’t know why I said you smelt of old bananas.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She looked over her shoulder and smiled, and I introduced her to Bruce, our pet fruit fly, to show that it was not only the art-school crowd who knew how to have a good time.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-9"
  }, [_vm._v("49.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("caution")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_vm._v("The tour continued. I showed her the cold room, where we remarked on how cold it was, and the 37-degree room.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Why")]), _vm._v(" 37 "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("degrees?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Because it’s the temperature inside the human body. This is what it feels like to be inside someone.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Sexy,’ said Connie, deadpan, and we moved on. I showed her dry ice, I showed her the centrifuge in action. Through a microscope we looked at cross sections of the tongue of a rat that had been infected with parasitic worms. Oh yes, it was quite a date, and I began to note the amused faces of my colleagues working late as usual, mouths open, eyebrows raised at this lovely woman peering into flasks and test tubes. I gave her some Petri dishes, to mix her paints in.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When she’d seen enough we went, at her suggestion, to a tiny Eastern European restaurant that I had walked past many times without ever imagining I might enter. Faded, dimly lit, it was like stepping into a sepia photograph. A hunched and ancient waiter took our coats and showed us to a booth. At Connie’s suggestion, we drank vodka from small, thick glasses, then ate velvety soup a shade of burgundy, delicious dense dumplings and pancakes and syrupy red wine and sat side by side in the corner of the almost empty room, and soon we were fuzzy-headed and happy and even almost at ease. Rain outside, steam on the windows, an electric-bar fire blazing; it was wonderful.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You know what I envy about science? The certainty. You don’t have to worry about taste or fashion, or wait for inspiration or for your luck to change. There’s a . . . methodology – is that a science word? Anyway, the point is you can just work hard, chisel away and eventually you’ll get it right.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Except it’s not quite as easy as that. Besides, you work hard.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She shrugged and waved her hand. ‘Well, I used to.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I saw some of your pictures. I thought they were amazing.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She frowned. ‘When did you see them?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Last weekend. While you were asleep. They were beautiful.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Then they were probably my flatmate’s.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, they were yours. Hers I didn’t like at all.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Fran is very successful. She sells a lot.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well, I don’t know why.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘She’s very talented, and she’s my friend.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Of course, but I still loved yours. I thought they were very . . .’ I searched for some artistic term. ‘Beautiful. I mean, I don’t really know much about art—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But you know what you like?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Exactly. Also, you can draw terrific hands.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She smiled, looked at her own hand, splayed the fingers and then placed it over mine. ‘Let’s not talk about art. Or fruit flies.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Okay.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘How about last weekend instead? What happened, I mean.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Fine,’ I said and thought,")]), _vm._v(" "), _c('i', [_vm._v("here it is, the bolt gun")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What did you want to say?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I don’t know. Or rather, I thought I did.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Go on.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She hesitated. ‘You go first.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I thought a moment. ‘Okay. It’s very simple. I had an amazing time. I loved meeting you. It was fun. I’d like to do it again.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That’s it?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That’s all.’ It was by no means all, but I didn’t want to alarm her. ‘You?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I thought . . . I thought the same. I had a")]), _vm._v(" "), _c('i', [_vm._v("happy")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("time, unusually. You were very sweet. No, that’s wrong, I don’t mean that, I mean you were thoughtful and interesting and I liked sleeping with you too. Very much. It was fun. Your sister was right – you were what I needed.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I had found myself in this situation often enough to recognise the imminent arrival of a ‘but’ . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But I don’t have a very good track record with relationships. I don’t associate them with happiness, certainly not the last one.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Angelo?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Exactly. Angelo. He wasn’t very nice to me and he’s made me . . . I suppose, I want to be . . . cautious. I want to proceed with caution.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But you want to proceed?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘With caution.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘With caution. Which means?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("She considered for a moment, biting her lip, then leant forward. ‘Which means that if we got the bill right now and went outside, if we found a taxi and went home to your bed, then I’d be very happy.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Then she kissed me.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(". . .")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(". . .")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(". . .")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(". . .")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(". . .")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Waiter!’")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("50.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the wild party in room")]), _vm._v(" 603")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The party started at a time you might reasonably expect most parties to stop, the usual treble and bass boom-tsk of electronic music soon replaced by a low-frequency oom-pah oom-pah with a distinctive comb-and-paper buzz.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Is that . . . an accordion?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Uh-huh,’ mumbled Connie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Albie doesn’t play the accordion.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Then he has an accordionist in his room.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Oh, good grief.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Now the asthmatic chug resolved into four familiar stabbing minor chords, played in rotation, accompanied by much foot-stomping and thigh-slapping percussion, provided by my son.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What is this song? I know this song.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I think it’s “Smells Like Teen Spirit”.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s what?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Listen!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And sure enough, it was.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("When – if – I thought of accordionists, the word suggested an olive-skinned male wearing a Breton top. But here, Nirvana’s howl to youthful alienation was bellowed by a primal female voice, a kind of soulful town crier, with Albie now accompanying her on percussive guitar, his chord changes always just a little way behind.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I think they call it jamming,’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘As in jamming your fingers in your ears,’ said Connie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Resigning myself to a long night, I turned on the light and reached for my book, a history of World War II, while Connie sandwiched her head between two foam pillows and assumed a horizontal brace position. The accordion, like the bagpipes, is part of the select group of instruments that people are paid to stop playing, but for the next forty-five minutes my son’s mysterious guest pushed at the musical limits of the squeezebox, regaling much of the fifth, sixth and seventh floors of the Good Times Hotel with, amongst others, a boisterous ‘Satisfaction’, a sprightly ‘Losing My Religion’ and a version of ‘Purple Rain’ so long and repetitive that it seemed to stretch the very fabric of time.")]), _c('span', {
    staticClass: "LB4_Highlighted_label_4 CharOverride-1"
  }, [_c('b', [_vm._v("‘We are enjoying the concert, Albie,’")])]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I texted,")]), _vm._v(" "), _c('span', {
    staticClass: "LB4_Highlighted_label_4 CharOverride-1"
  }, [_c('b', [_vm._v("‘but it’s a little late’")]), _vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I pressed send and waited for the message to be received.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I heard the bleep of a text arriving on the other side of the wall. A pause, and then ‘Moondance’ sung by emphysemic wasps.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Perhaps he didn’t read my text.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Hm.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Perhaps I should call reception and complain. What’s French for “remove the accordionist from room")]), _vm._v(" 603"), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("”?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Hm.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Seems a bit disloyal, though, complaining about my own son.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Hasn’t stopped you in the past.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Or shall I just knock on the—?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Douglas, I don’t care what you do as long as you stop talking!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Hey! I’m not the one with the accordion!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Sometimes I think an accordion would be preferable.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What does that mean?!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It doesn’t mean—It’s two thirty, just . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And then the noise stopped.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Thank you, God!’ said Connie. ‘Now, let’s go to sleep.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But the irritation lingered and we lay beneath its cloud, contemplating other nights we had spent like this, dwelling on a moment’s unkindness, impatience or thoughtlessness.")]), _vm._v(" "), _c('i', [_vm._v("I think our marriage has run its course. I think I want to leave you")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And then a jolt, like a bass drum behind our heads, followed by the particular, insistent thump-thump-thump of a headboard banging against a wall.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘They’re jamming,’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Oh, Albie.’ Connie laughed, her forearm across her eyes. ‘That’s just perfect.’")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-7"
  }, [_vm._v("51.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the rock accordionist")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We met the beguiling musician the next morning in the hotel’s gloomy basement breakfast room. Uncharacteristically for Albie, they were up before us, though it was hard to see the girl’s face at first, clamped as it was to Albie with the tenacity of a lamprey eel. I cleared my throat, and they peeled apart.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Hello! You must be Douglas and Connie! Christ, look at you, Connie, you’re gorgeous! No wonder your son is so hot, you’re a be-auty.’ Her voice was gravelly, Antipodean. She took my hand. ‘And you’re a very beautiful man too, Dougie! Ha! We were just having some breakfast, the breakfast here is a-mazing. And it’s all free!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well, not exactly")]), _vm._v(" "), _c('i', [_vm._v("free")]), _vm._v(" . . .’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Here – let me move Steve out of the way.’ Steve, it seemed, was the name of her accordion. Steve had his very own chair, where he sat toothily grinning. ‘Come on, Steve, let poor Mr Petersen sit down, he looks wasted.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘We enjoyed your concert last night.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Aw, thank you!’ She smiled, then used her fingers to arrange her features into a clown’s sad face. ‘Or did you not really mean that?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You play very well,’ said Connie. ‘We’d have enjoyed it more before midnight.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Oh no! I’m so sorry. No wonder you look fucked, Mr Petersen. You’ll have to come and see me play at a reasonable hour.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You’re actually playing a concert?’ said Connie, with a hint of incredulity.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well,")]), _vm._v(" "), _c('i', [_vm._v("concert")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("’s a big word. Only outside the Pompidou.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You’re a busker?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I prefer “street performer”, but yes!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I don’t")]), _vm._v(" "), _c('i', [_vm._v("think")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("my face fell, I tried not to let it, but it’s true that I was wary of any activity prefixed with the word ‘street’. Street art, street food, street theatre, in all cases ‘street’ preceding something better carried on indoors.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘She does an amazing “Purple Rain”,’ mumbled Albie, who was slumped diagonally across the banquette like the victim of a vampire.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Oh we know, Albie, we know,’ said Connie, regarding the accordionist through narrowed eyes. The girl, meanwhile, was scooping the contents of many tiny jars of jam into a croissant. ‘I hate these little jars, don’t you?")]), _vm._v(" "), _c('i', [_vm._v("So")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("shitty for the environment. And")]), _vm._v(" "), _c('i', [_vm._v("so")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("frustrating!’ she said before cramming her entire tongue into one.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’m sorry, we didn’t quite get your—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Cat. As in the hat!’ She patted the black velour bowler that she wore at the back of her head.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘And are you Australian, Cat?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Albie tutted. ‘She’s from")]), _vm._v(" "), _c('i', [_vm._v("New Zealand")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Same thing!’ She gave a loud bark of a laugh. ‘You guys better get some breakfast in you, before I eat it all. Race you!’")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-5"
  }, [_vm._v("52.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("on practical ethics in the breakfast buffet system")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Over the years, at conferences and seminars, I’ve had some experience of the breakfast buffet system and have noticed that when confronted with a table of ostensibly ‘free’ food, some people behave with moderation and some as if they’ve never tasted bacon before. Cat was of the group that believes that ‘eat as much as you like’ is a gauntlet thrown down. She stood at the juice dispenser, pouring a glass then downing it, pouring a glass then downing it; juice-hanging, I call it and I wondered, why not just open the tap and lie beneath it? I smiled at the waiter who shook his head slowly in return, and it occurred to me that if management made the connection between last night’s accordion workout and the woman now piling a great mound of strawberries and grapefruit segments into her bowl, then we might be in very real trouble.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We shuffled along the counter. ‘So what brings you to the Eternal City, Cat?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Paris isn’t the Eternal City,’ said Connie. ‘The Eternal City is Rome.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘And it’s not eternal,’ said Albie, ‘it just feels like it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Cat laughed and wiped juice from her mouth. ‘I don’t live here, I’m just passing through. I’ve been bumming round Europe ever since college, living here, living there. Today it’s Paris, tomorrow Prague, Palermo, Amsterdam – who knows!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes, we’re the same,’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Except we have a laminated itinerary,’ said Connie, examining the empty grapefruit container.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s not laminated. What I mean is, we’re going to Amsterdam tomorrow.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Lucky you! I love the ’Dam, though I always end up doing something I regret, if you know what I mean. Party town!’ She was filling a second plate now, balancing it on her forearm like a pro and focusing on proteins and carbohydrates. Lifting the visor on the bacon tray, she inhaled the meaty vapour with eyes closed. ‘I’m a strict vegetarian with the exception of cured meats,’ she said, loading dripping coils of the stuff onto a plate already overflowing with cheese, smoked salmon, brioche, croissants . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That’s certainly quite a breakfast you’ve got there!’ I said, smile fixed.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I know! Albie and me’ve worked up quite an appetite,’ and she gave a low, dirty laugh and snapped at his buttock with the bacon tongs while Albie grinned sheepishly at his plate. ‘Anyway,’ she said, ‘most of this is for later on.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("That, to my mind, was crossing a line. The buffet was not a picnic-making facility nor a come-one-come-all larder. I had resolved to be nice to Albie’s new friends and their eccentricities, but this was theft, plain and simple, and when a banana followed a jar of honey into the capacious pockets of her velvet shorts I felt that I could restrain myself no more.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Don’t you think maybe you should put some of that back, Cat?’ I said, light-heartedly.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Beg pardon?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘The fruit, the jars of honey. You only need one, two at the most.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Dad!’ said Albie. ‘I can’t believe you’d say that!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well, I just think it’s a bit excessive . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Awk-ward!’ trilled Cat in an operatic falsetto.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘She’s not eating it all now.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Which is exactly my point, Albie.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, fair enough, fair point – here, here . . .’ And Cat began tossing jars and fruit and croissants back on to the table willy-nilly.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, no, take what you’ve got, I just think maybe don’t put stuff in your pockets—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘See what I mean, Cat?’ said Albie, gesturing towards me with an open hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Albie . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I told you, this is what he’s like!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Albie! Enough. Sit.’ This was Connie, with her sternest face. Albie knew well enough not to argue, and we returned to the table, took our seats and listened to Cat . . .")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-5"
  }, [_vm._v("53.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the cat in the hat")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(". . . how she loved New Zealand, how beautiful it was but how she’d grown up in a boring suburb of Auckland, so dull and middle-class, mile upon mile of identical houses. Nothing ever happened there – or rather, things did happen there, terrible things, but no one ever talked about them, they just closed their eyes and carried on with their dull, conventional, boring lives and waited for death.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Sounds like where we live,’ said Albie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Connie sighed. ‘I challenge you, Albie, to name one terrible thing that’s happened to you in your whole life. Just one. Cat, poor Albie here is scarred because we didn’t let him have Coco Pops back in")]), _vm._v(" 2004"), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You don’t know everything about me, Mum!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well, I do as a matter of fact.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, you don’t!’ Albie protested, looking betrayed. ‘And since when were you this great defender of home, Mum? You said you hated it too.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Had she? Connie, moving on, said, ‘Cat, my son is posturing for your benefit. Carry on. You were saying.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Cat was ramming salami inside a baguette with a dirty thumb. ‘Anyway, my dad, who’s a complete and utter")]), _vm._v(" "), _c('i', [_vm._v("bastard")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("insisted that I study")]), _vm._v(" "), _c('i', [_vm._v("engineering")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("at the uni, which was a complete waste of time . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Albie was grinning at me but I declined to meet his eye and poured more coffee. ‘Well, not a complete waste of time,’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It is if you hate it. I wanted to experience things, see things.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘So what did you study instead?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Ventriloquism.’ She held a marmalade jar to her ear and a small voice said,")]), _vm._v(" "), _c('i', [_vm._v("help me! help me!")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That got me into puppetry and improv and I joined this street theatre group, operating these giant marionettes, and we just hit the road, travelled all over Europe, had a wild time until they all wimped out and went home to their little jobs and little houses and dull, predictable little lives. So I carried on, travelling solo. Love it! Haven’t seen my parents now for four years.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Oh Cat, that’s terrible,’ said Connie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s not terrible! It’s been amazing for me. No roots, no rent, meeting the most incredible people. I can live wherever I want now. Except Portugal. I’m not allowed into Portugal, for reasons which I am not at liberty to divulge . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘But what about your parents?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I send my mum postcards. I phone her twice a year, Christmas and birthday. She knows I’m fine.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Hers or yours?’ said Connie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’m sorry?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You said you phone her Christmas and birthday. D’you phone her on")]), _vm._v(" "), _c('i', [_vm._v("her")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("birthday or")]), _vm._v(" "), _c('i', [_vm._v("your")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("birthday?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The question seemed to puzzle Cat")]), _vm._v(". ‘"), _c('i', [_vm._v("My")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("birthday, of course,’ she said, and Connie nodded.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘And your father?’ I asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘My father can go screw himself,’ she said proudly, popping the bread into her mouth, and I noted how Albie could barely contain his admiration.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That seems a little harsh.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Not if you met him. If you met him, it’s a grrr-eat review!’ She laughed her laugh again, the kind you see in films to denote madness and the waiter’s stare got a little harder. Despite my best efforts, I was finding it difficult to warm to Cat. She was somewhat older than Albie, which made me feel absurdly defensive of him, and her skin had a chafed look, as if it had been scoured with some sort of abrasive – my son’s face, presumably. There were panda smudges around her eyes and a red smear around her mouth, again attributable to my son, and high arched eyebrows that seemed drawn on. What did she remind me of? When I first arrived at university I attended a fancy-dress screening of")]), _vm._v(" "), _c('i', [_vm._v("The Rocky Horror Picture Show")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("with the aforementioned Liza Godwin, which remains one of the most wearying evenings of enforced wackiness that I have ever writhed through in my life. The things I did for love! I am not a religious man but I vividly remember sitting in my seat wearing a pair of Liza Godwin’s torn tights, with a lipsticked rictus grin on my face, praying, please, God, if you do exist, let me not do ‘The Time Warp’ again.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And yes, there was something of that")]), _vm._v(" "), _c('i', [_vm._v("Rocky Horror")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("quality to Cat, and perhaps this appealed to our son, his hand on the small of her back, her fingers exploring the torn knees of his jeans. It was all rather disturbing, and I must confess a certain relief when she said:")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Okay, you good people, it was a pleasure to encounter you. You’ve got a fine young man here!’ She slapped his thigh for emphasis.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes, we’re aware of that,’ said Connie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Enjoy the sights! Young man, escort me to the door – I don’t want the buffet police to wrestle me to the floor and strip-search me!’ There was a guffaw and the scrape of a chair as she hoisted the accordion called Steve from his seat and squashed her bowler hat down on to her curls. A high trill from Steve, and they were gone.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We sat in the kind of silence that follows a collision, until Connie said, ‘Never trust a woman in a bowler hat.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We laughed, enjoying the sweet marital pleasure of shared dislike. ‘“Mum, Dad, I’d like you to meet the woman I intend to marry.”’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Douglas, don’t even joke about it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well I liked her.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Is that why you told her to put her breakfast back?’ giggled Connie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Was that too much, d’you think?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘For once, Douglas, I say no.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘So what do you think he sees in her? I think it’s the laugh.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I don’t think it’s")]), _vm._v(" "), _c('i', [_vm._v("just")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the laugh. I think sex might have something to do with it too. Oh, Albie,’ she sighed, and a look of awful sadness came across her face. ‘Douglas,’ she said, her head on my shoulder, ‘our boy’s all grown-up now.’")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_vm._v("54. "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("oversharing, undersharing")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I had hoped the three of us would spend our last day in Paris together, but Connie felt tired and insisted, rather snappily, that she’d like just one minute to herself if that was all right, just one single minute if that wasn’t against the law. With just each other for company, my son and I had a tendency to panic, but we steeled ourselves and set out for the Musée d’Orsay.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("The weather had turned, the city humid beneath low, dense cloud. ‘Storm later,’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Nothing from Albie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘We liked Cat,’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Dad, you don’t have to pretend, because I don’t care.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘We did, we did! We thought she was very interesting. Challenging.’ A short distance, silence, then:")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘D’you think you’ll stay in touch?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Albie wrinkled his nose. We had not spent a great deal of time discussing affairs of the heart, my son and I. There were friends – Connie’s friends, mainly – who had conversations of startling frankness with their children, constantly hunkering down on baggy sofas to confer on relationships, sex, drugs, emotional and mental health, taking every available opportunity to parade around naked, because isn’t that what teenage kids really want? Evidence of time’s decay brandished at eye-level? While I found this approach smug and contrived, I also accepted that there was room for improvement on my part, a certain reticence that I should do my best to overcome. The nearest my own father came to ‘opening up’ about relationships was a selection of National Health leaflets on sexually transmitted diseases that he left fanned out on my pillow, a parting gift before I left for university and all the information I would ever need on the workings of the human heart. My mother changed the television channel every time two people kissed. Both had passed through the permissive")]), _vm._v(" 1960"), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("s untouched. It might as well have been the")]), _vm._v(" 1860"), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("s. How my sister and I ever came to be, I’ve frankly no idea.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But wasn’t emotional openness something I’d intended to work on? Perhaps this was an opportunity to chat about the turmoil of these teenage years, and in turn I could confide some of the ups and downs of married life. With this in mind, I took a short detour to rue Jacob, the hotel where Connie and I had stayed eighteen years ago, and I paused and held Albie’s arm.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You see this hotel?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yes.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That window, up there? Corner of the second floor, the one with the yellow curtains?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What about it?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I placed my hand on his shoulder. ‘That, Albert Samuel Petersen, is the bedroom where you were conceived!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Perhaps it was too much too soon. I’d hoped that there might be something rather poetic about it, seeing the exact place where sperm and egg had fused and he had blinked into existence. Part of me thought that he might find it amusing, imagining his parents as their younger selves, so different from our current, less carefree incarnations. I’d hoped that he might even be touched by my nostalgia for his creation in an act of love that, in my memory at least, had been freighted with emotion and care.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Perhaps I hadn’t thought it through.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘"), _c('i', [_vm._v("What?")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Right there. In that room. That is where")]), _vm._v(" "), _c('i', [_vm._v("you")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("came to be.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("His face shrivelled into a mask of disgust. ‘Now there’s an image I will never get out of my head.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well, how else do you think it happened, Albie?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I know it")]), _vm._v(" "), _c('i', [_vm._v("happened")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I just don’t want to be forced to")]), _vm._v(" "), _c('i', [_vm._v("think")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("about it!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I thought you’d like to know. I thought that you’d be . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("He began to walk on. ‘Why are you being like this?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Like what?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Saying all this stuff. It’s very weird, Dad.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s not weird, it’s a friendly conversation.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘We’re not friends. You’re my father.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That doesn’t mean . . . adults, then. We’re both adults now, I thought we could talk like adults too.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Yeah, well thanks for oversharing, Dad.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("We walked on and I considered the concept of ‘oversharing’, and what undersharing might be, and whether it was ever possible to settle on something in between.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-9"
  }, [_vm._v("55.")]), _vm._v(" "), _c('i', [_vm._v("épater le bourgeois")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Soon we were at the Musée d’Orsay, standing in the extraordinary concourse of the old converted train station. ‘Look at that incredible clock!’ I said, in my awed voice. Albie, too cool for awe, walked on and began to take in the paintings. I like the Impressionists, which I know is not a particularly fashionable line to take, but Albie was making a great show of his indifference, as if it were me who’d painted the poplar trees, the young girls seated at the piano.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Then suddenly we found something more to his taste:")]), _vm._v(" "), _c('i', [_vm._v("L’Origine du Monde")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("by Gustave Courbet. The style and techniques were the same that you might see applied to ballet dancers or a bowl of fruit, but here the subject was the splayed legs of a woman, her face beyond the frame. It was a disconcerting picture, explicit and unflinching, and I did not love it. Generally speaking I dislike being shocked. Not because I’m a prude, but because it all seems so juvenile and easily achieved. ‘Where")]), _vm._v(" "), _c('i', [_vm._v("do")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("they get their ideas?’ I said, glancing at it and moving on.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But Albie clearly wasn’t going to miss an opportunity to make me uncomfortable, and he stopped and stared and stared. Determined not to seem priggish, I doubled back and returned to his side.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Now")]), _vm._v(" "), _c('i', [_vm._v("that")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("is oversharing!’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s quite confrontational, isn’t it?’ I said. Albie sniffed and tilted his head, as if that made a difference. ‘Amazing to think it was painted in")]), _vm._v(" 1866"), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Why? You think naked women were different back then?’ He was walking up and peering at the canvas now, so close that I thought the security guard might intervene.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, I just mean that we tend to think of the past as inherently conservative. It’s interesting to note that outrage is not a late-twentieth-century invention.’ This was")]), _vm._v(" "), _c('i', [_vm._v("good")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I thought. It sounded like the kind of thing Connie might say, but Albie only scowled.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I don’t think it’s outrageous. I think it’s beautiful.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Me too,’ I said, though without conviction. ‘Great picture. Terrific.’ I latched on to the caption once again.")]), _vm._v(" ‘"), _c('i', [_vm._v("The Origins of the World")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(".’ When I’m nervous I tend to read things out – captions, signage, often more than once")]), _vm._v(". ‘"), _c('i', [_vm._v("The Origins of the World")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Witty title,’ and I expelled air sharply through my nose to show just how damned hysterical I found it. ‘I wonder what the model thought of it. I wonder if she came round to look at the canvas and said, “Gustave, it’s like looking in a mirror!”’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("But Albie had already produced his sketchbook from his bag, because it wasn’t enough to stare at this anonymous woman’s private parts, clearly he was going to have to sketch them, too.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Meet you in the gift shop,’ I said, and left him there, madly cross-hatching and shading in.")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-8"
  }, [_vm._v("56.")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("the comfort zone")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Then, on our final night in Paris we all went to a Vietnamese restaurant, but I had to leave early because I was injured by my soup.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I have always had a poor record with heavily spiced food, believing, not unreasonably, that if a substance burns my fingers I shouldn’t put it in my stomach. Of course Albie loves fiery food, thinking that it reflects his tempestuous personality or politics or something. As for Connie, her mood had improved a little since the great breakfast-buffet farrago, but she was wearying of bistros. ‘I swear, if I see another duck leg, I shall scream.’ Albie suggested Vietnamese, and wasn’t I meant to be trying new things and leaving my so-called ‘comfort zone’? So at Albie’s suggestion we set off in our wobbly convoy of bicycles to a Vietnamese restaurant in Montparnasse.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_vm._v("‘“"), _c('i', [_vm._v("Authentiquement épicé")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("”!’ Albie read approvingly in the menu. ‘Which basically means “bloody hot”!’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I ordered some sort of beef soup, specifying")]), _vm._v(" ‘"), _c('i', [_vm._v("pas trop chaud, s’il vous plaît")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("’, but the bowl, when it arrived, was so heavily dosed with small vicious red chillis that I wondered if perhaps it was some sort of practical joke. Perhaps Albie had put them up to it, perhaps the chefs’ faces were pressed to the little round window, chuckling away. Either way I was having to drink a great deal of beer to cool my palate.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Too much for you, Dad?’ he grinned.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Just a little.’ I ordered one more beer.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You see?’ grinned Connie. ‘Anything that isn’t boiled meat in gravy . . .’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘That’s not true, Connie, you know it’s not,’ I said, a little snappily perhaps. ‘As a matter of fact, it’s delicious.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("And then it wasn’t delicious anymore. I had been attempting to avoid the chillies by sieving the soup through my teeth, but something must have slipped through, because my mouth was suddenly ablaze. I drained the beer and, in slamming the glass down, flipped the large ceramic spoon from the broth, catapulting a ladleful into my right eye. So heavily dosed with lime juice and chilli was this broth that I was momentarily blinded, scrabbling around the table for a napkin, grabbing one that had been discarded by Albie and was smeared with the chilli sauce from his spare ribs, which I then proceeded to rub into the affected eye and, somehow, the unaffected eye too. If he hadn’t been laughing no doubt Albie would have warned me, but tears were pouring down my face now, and Albie and Connie’s amusement had turned to embarrassment and concern as I stumbled blindly to the bathroom, bumping into several diners, stumbling through a beaded curtain into first the ladies’ –")]), _vm._v(" "), _c('i', [_vm._v("desolé! desolé!")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("– then the gentlemen’s toilets and finally locating the world’s smallest and most impractical handbasin, into which I attempted to squeeze my head, scraping my forehead with the tap and pouring first scalding hot, then cold water into my eye. I stood there, spine twisted, with the water jetting uncomfortably onto my eyeball, then into my mouth which was now mercifully numb, with a chemical throb that recalled the removal of an impacted molar some years ago.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I stayed like this for some time.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Eventually I stood and examined my reflection, my shirt soaked and clinging to my chest, my forehead bleeding, my tongue swollen and lips apparently rouged, my right eye sealed tight. I peeled the lid back, the sclera heavily veined and the colour of tomato soup. Peering at the ceiling, I noted that some sort of scratch, like a hair on a camera lens, had appeared at the edge of my vision, dancing around and out of sight as I attempted to examine it further. A scar.")]), _vm._v(" "), _c('i', [_vm._v("This")]), _vm._v(", "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I thought,")]), _vm._v(" "), _c('i', [_vm._v("is why we have comfort zones, because they are comfortable. What can possibly be gained by leaving them?")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("As I returned to the table, Albie and Connie regarded me with the solemn faces that precede bouts of hilarity. When the laughter broke, I attempted to join in, because I wanted to be fun rather than a figure of it. I had prepared a line to this end: ‘You see? This is why we wear protective goggles in the lab,’ I said, though the joke didn’t really land.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘You look as if you’ve been tied to a chair and beaten,’ said Connie.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’m fine. Fine!’ I said, smiling, smiling as I pushed the bowl away. ‘Here, you have it.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I think the food here is amazing.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well, I’m pleased,’ I said, ‘but personally I prefer food that doesn’t actually injure you.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Connie sighed. ‘It hasn’t")]), _vm._v(" "), _c('i', [_vm._v("injured")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("you, Douglas.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It has! It has actually scarred my cornea. From now on every time I look at a plain white surface I’ll see that soup.’ This set them off again, and suddenly I’d had enough. Wasn’t I trying? Wasn’t I doing my best, making an effort? I drained a beer, my third or fourth I think, scraping my chair as I stood to go.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Actually, I’m going to walk back to the hotel.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Douglas,’ said Connie, her hand on my arm, ‘don’t be like that.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, you’ll be far happier by yourselves. Here . . .’ I was tugging money from my wallet now, belligerently tossing notes on to the table in a way that I’d seen in films. ‘That ought to cover it. Amsterdam train’s at nine fifteen, so early start. Please don’t be late.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Douglas, sit down, wait for us, please—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_SA"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I need some fresh air. Goodnight. Goodnight. I’ll find my own way home.’")])]), _vm._v(" "), _c('h3', {
    staticClass: "HA_Head"
  }, [_c('span', {
    staticClass: "NonAligning-Figures_NonAligningFigs_Regular _idGenBNMarker-5"
  }, [_vm._v("57.")]), _vm._v(" "), _c('i', [_vm._v("je suis désolé mais je suis perdu")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1_Full-out"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I got lost, of course. The sinister black slab of the Montparnasse Tower was behind, then in front of me, to my left and right, hopping around, and now the back streets had opened out into an avenue, wide and dull and unpopulated, an elegant dual carriageway that would lead me eventually to the")]), _vm._v(" "), _c('i', [_vm._v("Périphérique")]), _vm._v(". "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I was walking towards a motorway, soaked through with beer, soup, water and sweat, drunk and blinded in one eye, neither loveable nor full of love, full of nothing but irritation and frustration and self-pity, and lost, quite lost, in this idiotic city. City of Light. City of Bloody, Bloody Light.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I had not dared to dwell on the idea, but when we’d set out I had imagined that this trip might in some way repair our relationship, perhaps even lead to a change of heart on Connie’s part. I")]), _vm._v(" "), _c('i', [_vm._v("think")]), _vm._v(" "), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I want to leave you, she’d said, and didn’t ‘think’ imply some doubt, the possibility of persuasion? Perhaps the newness of our surroundings would recall when we were new to each other. But it was absurd to think a city could make a difference, absurd to think oil paintings and marble statues and stained glass could make that change. Place had nothing to do with it.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Now I saw the great gilded dome of Les Invalides against the purple sky, the searchlights on the Eiffel Tower swooping as if hunting down a fugitive. The air had taken on that charged quality that precedes a summer storm and I realised I was still some distance from the hotel. They’d be in bed now, quite happily asleep, my family. The family I was about to lose, if I’d not lost them already, and I trudged on down that long, dull deserted avenue, wondering why it was inevitable that my plans should fail.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I turned right at the Musée Rodin. Through a gap in the wall, a sculpture of five men stood in a huddle, wailing and moaning in various attitudes of despair, and this seemed like an apt spot to rest. I settled on the kerb. My phone was ringing – Connie, of course. I considered not answering but I’ve never been able to ignore Connie’s call.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Hello.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Where are you, Douglas?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I seem to be outside the Rodin Museum.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘What on earth are you doing there?’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Seeing an exhibition.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘It’s one in the morning.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I got a little lost, that’s all.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I expected you to be waiting at the hotel.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I’ll be back soon. Go to sleep.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I can’t sleep without you here.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Nor with me, it would seem.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No. No, that’s right. It’s . . . a dilemma.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("A moment passed.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I got a little . . . het up. I apologise,’ I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘No, I do. I know you and Albie like to wind each other up, but I shouldn’t join in.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Let’s talk no more about it. Amsterdam tomorrow.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Fresh start.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Exactly. Fresh start.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Well. Hurry back. There’s going to be a storm.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘I won’t be long. Try to get some—’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘We do love you, you know. We don’t always show it, I’m aware of that. But we do.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I took a deep breath. ‘Well. As I said, I’ll be back soon.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Great. Hurry back.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Bye.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Bye.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("‘Bye.’")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1_Body_text_1 _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("I sat for a moment, then hauled myself to my feet and quickened my pace, determined to beat the imminent rain. Amsterdam tomorrow. Perhaps Amsterdam would be different. Perhaps everything would go right in Amsterdam.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7390fa14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062365606_Chapter_2.vue
// module id = 84
// module chunks = 0